<template>
    <v-container class="my-5">
        <!--    Diálogo Modal Persistente para mostrar la Info de Residente Principal y Residentes    -->
        <v-dialog v-model="dialogInfoMainResidentAndResidents" scrollable max-width="1000px">
            <v-skeleton-loader
                    scrollable max-width="1000px"
                    v-if="loadingSkeleton"
                    type="list-item-two-line, card, image, image, table-tfoot"
            >
            </v-skeleton-loader>
            <v-card v-else class="elevation-5">
                <v-toolbar
                        dark
                        color="primary"
                >
                    <v-toolbar-title>
                        <v-icon
                                right
                                dark
                        >
                            mdi-home-edit
                        </v-icon>
                        {{$t('validar_datos_vivienda')}}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                            class="align-self-end"
                            color="red"
                            icon
                            @click="dialogInfoMainResidentAndResidents = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text v-if="houseInfo.length > 0">
                    <v-window v-model="step">
                        <v-window-item :value="1">
                            <h2>{{$t('datos_vivienda')}}</h2>
                            <br>
                            <v-layout row wrap>
                                <v-flex xs12 sm6>
                                    <v-text-field
                                            class="pl-3 pr-3"
                                            :label="$t('nombre_calle')"
                                            :value="houseInfo[0].street"
                                            readonly
                                            outlined
                                    >
                                    </v-text-field>
                                </v-flex>
                                <v-flex xs12 sm3>
                                    <v-text-field
                                            class="pl-3 pr-3"
                                            :label="$t('numero_casa')"
                                            :value="houseInfo[0].number"
                                            readonly
                                            outlined
                                    >
                                    </v-text-field>
                                </v-flex>
                            </v-layout>
                            <br>
                            <v-divider></v-divider>
                            <br>
                            <h2>{{$t('datos_residente_principal')}}</h2>
                            <br>
                            <v-layout row wrap>
                                <v-flex
                                        class="pl-3 pr-3 pt-3 pb-3"
                                        xs12 sm6
                                >
                                    <v-img
                                            readonly
                                            outlined
                                            :src="houseInfo[0].main_residents[0].idUser.idFront"
                                    ></v-img>
                                </v-flex>
                                <v-flex
                                        class="pl-3 pr-3 pt-3 pb-3"
                                        xs12 sm6
                                >
                                    <v-img
                                            readonly
                                            outlined
                                            :src="houseInfo[0].main_residents[0].idUser.idBack"
                                    ></v-img>
                                </v-flex>
                            </v-layout>
                            <v-divider></v-divider>
                            <br>
                            <v-layout row wrap>
                                <v-flex xs12 sm6 md4>
                                    <v-text-field
                                            class="pl-3 pr-3"
                                            prepend-icon="mdi-account"
                                            :label="$t('Nombre')"
                                            :value="houseInfo[0].main_residents[0].idUser.first_name"
                                            readonly
                                            outlined
                                    >
                                    </v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md4>
                                    <v-text-field
                                            class="pl-3 pr-3"
                                            prepend-icon="mdi-account-outline"
                                            :label="$t('Apellido')"
                                            :value="houseInfo[0].main_residents[0].idUser.last_name"
                                            readonly
                                            outlined
                                    >
                                    </v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md4>
                                    <v-text-field
                                            class="pl-3 pr-3"
                                            prepend-icon="mdi-email"
                                            label="E-Mail"
                                            :value="houseInfo[0].main_residents[0].idUser.email"
                                            readonly
                                            outlined
                                    >
                                    </v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex xs12 sm6 md4>
                                    <v-text-field
                                            class="pl-3 pr-3"
                                            prepend-icon="mdi-cellphone"
                                            :label="$t('celular')"
                                            :value="houseInfo[0].main_residents[0].idUser.cellNumber"
                                            readonly
                                            outlined
                                    >
                                    </v-text-field>
                                </v-flex>
                            </v-layout>
<!--                            <v-divider></v-divider>-->
<!--                            <h2>{{$t('datos_residentes')}}</h2>-->
<!--                            <br>-->
<!--                            <v-data-table-->
<!--                                    :headers="headersResident"-->
<!--                                    :items="houseInfo[0].residents"-->
<!--                                    class="elevation-1"-->
<!--                                    :no-data-text="$t('no_records_yet')"-->
<!--                            >-->
<!--                                <template v-slot:item.puede_enviar="{ item }">-->
<!--                                    <v-icon-->
<!--                                            v-if="item.puede_enviar === true"-->
<!--                                            medium-->
<!--                                            color="primary"-->
<!--                                            class="mr-2"-->
<!--                                    >-->
<!--                                        mdi-check-->
<!--                                    </v-icon>-->
<!--                                    <v-icon-->
<!--                                            v-if="item.puede_enviar === false"-->
<!--                                            medium-->
<!--                                            color="red"-->
<!--                                            class="mr-2"-->
<!--                                    >-->
<!--                                        mdi-close-->
<!--                                    </v-icon>-->
<!--                                    {{ item.puede_enviar ? $t('Si') : 'No' }}-->
<!--                                </template>-->
<!--                                <template v-slot:item.action="{ item }">-->
<!--                                    <v-icon-->
<!--                                            medium-->
<!--                                            color="grey"-->
<!--                                            class="mr-2"-->
<!--                                            @click="editResident(item)"-->
<!--                                    >-->
<!--                                        mdi-account-search-->
<!--                                    </v-icon>-->
<!--                                </template>-->
<!--                            </v-data-table>-->
                        </v-window-item>
                    </v-window>
                </v-card-text>
                <v-card-actions>
                    {{$t('msg_reconoce_residentes')}}
                    <v-radio-group
                            row
                            v-model="confirm"
                            name="confirm"
                            :mandatory="false"
                    >
                        <v-radio
                                class="pl-3 pr-3"
                                :label="$t('Si')"
                                value=true
                                outlined
                        ></v-radio>
                        <v-radio
                                class="pl-3 pr-3"
                                label="No"
                                value=false
                                outlined
                        ></v-radio>
                    </v-radio-group>
                    <v-flex v-if="confirm === 'false'">
                        <v-textarea
                            v-model="feedback"
                            outlined
                            :placeholder="$t('msg_additional_comments')"
                            :label="$t('additional_comments')">
                        </v-textarea>
                    </v-flex>
                    <v-btn
                            class="align-center"
                            color="primary"
                            large
                            :loading="loading"
                            @click="activateDeleteUsers()"
                    >
                        {{$t('enviar')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--    Diálogo Modal Persistente para mostrar la Info del Pre-residente Principal y Residentes    -->
        <v-dialog v-model="dialogInfoPreMainResidentAndResidents" scrollable max-width="1000px">
            <v-skeleton-loader
                    scrollable max-width="1000px"
                    v-if="loadingSkeleton"
                    type="list-item-two-line, card, image, image, table-tfoot"
            >
            </v-skeleton-loader>
            <v-card v-else class="elevation-5">
                <v-toolbar
                        dark
                        color="primary"
                >
                    <v-toolbar-title>
                        <v-icon
                                right
                                dark
                        >
                            mdi-home-edit
                        </v-icon>
                        {{$t('validar_datos_vivienda')}}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                            class="align-self-end"
                            color="red"
                            icon
                            @click="dialogInfoPreMainResidentAndResidents = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text v-if="houseInfoPreMainResident.length !== 0">
                    <v-window v-model="step">
                        <v-window-item :value="1">
                            <h2>{{$t('datos_vivienda')}}</h2>
                            <br>
                            <v-layout row wrap>
                                <v-flex xs12 sm6>
                                    <v-text-field
                                            class="pl-3 pr-3"
                                            :label="$t('nombre_calle')"
                                            :value="houseInfoPreMainResident.idHouse.street"
                                            readonly
                                            outlined
                                    >
                                    </v-text-field>
                                </v-flex>
                                <v-flex xs12 sm3>
                                    <v-text-field
                                            class="pl-3 pr-3"
                                            :label="$t('numero_casa')"
                                            :value="houseInfoPreMainResident.idHouse.number"
                                            readonly
                                            outlined
                                    >
                                    </v-text-field>
                                </v-flex>
                            </v-layout>
                            <br>
                            <v-divider></v-divider>
                            <br>
                            <h2>{{$t('datos_residente_principal')}}</h2>
                            <br>
                            <v-layout row wrap>
                                <v-flex
                                        class="pl-3 pr-3 pt-3 pb-3"
                                        xs12 sm6
                                >
                                    <v-img
                                            readonly
                                            outlined
                                            :src="houseInfoPreMainResident.idUser.idFront"
                                    ></v-img>
                                </v-flex>
                                <v-flex
                                        class="pl-3 pr-3 pt-3 pb-3"
                                        xs12 sm6
                                >
                                    <v-img
                                            readonly
                                            outlined
                                            :src="houseInfoPreMainResident.idUser.idBack"
                                    ></v-img>
                                </v-flex>
                            </v-layout>
                            <v-divider></v-divider>
                            <br>
                            <v-layout row wrap>
                                <v-flex xs12 sm6 md4>
                                    <v-text-field
                                            class="pl-3 pr-3"
                                            prepend-icon="mdi-account"
                                            :label="$t('Nombre')"
                                            :value="houseInfoPreMainResident.idUser.first_name"
                                            readonly
                                            outlined
                                    >
                                    </v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md4>
                                    <v-text-field
                                            class="pl-3 pr-3"
                                            prepend-icon="mdi-account-outline"
                                            :label="$t('Apellido')"
                                            :value="houseInfoPreMainResident.idUser.last_name"
                                            readonly
                                            outlined
                                    >
                                    </v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md4>
                                    <v-text-field
                                            class="pl-3 pr-3"
                                            prepend-icon="mdi-email"
                                            label="E-Mail"
                                            :value="houseInfoPreMainResident.idUser.email"
                                            readonly
                                            outlined
                                    >
                                    </v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex xs12 sm6 md4>
                                    <v-text-field
                                            class="pl-3 pr-3"
                                            prepend-icon="mdi-cellphone"
                                            :label="$t('celular')"
                                            :value="houseInfoPreMainResident.idUser.cellNumber"
                                            readonly
                                            outlined
                                    >
                                    </v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-window-item>
                    </v-window>
                </v-card-text>
                <v-card-actions>
                    {{$t('msg_reconoce_residentes')}}
                    <v-radio-group
                            row
                            v-model="confirm"
                            name="confirm"
                            :mandatory="false"
                    >
                        <v-radio
                                class="pl-3 pr-3"
                                :label="$t('Si')"
                                value=true
                                outlined
                        ></v-radio>
                        <v-radio
                                class="pl-3 pr-3"
                                label="No"
                                value=false
                                outlined
                        ></v-radio>
                    </v-radio-group>
                    <v-flex v-if="confirm === 'false'">
                        <v-textarea
                            v-model="feedback"
                            outlined
                            :placeholder="$t('msg_additional_comments')"
                            :label="$t('additional_comments')">
                        </v-textarea>
                    </v-flex>
                    <v-btn
                            class="align-center"
                            color="primary"
                            large
                            :loading="loading"
                            @click="activateDeleteUsersPreMainResident()"
                    >
                        {{$t('enviar')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--    Diálogo Modal Persistente para mostrar la Info de Residente con Solicitud de Domicilio Adicional    -->
        <v-dialog v-model="dialogInfoResidenceRequest" scrollable max-width="1000px">
            <v-card v-if="residenceRequestInfo" class="elevation-5">
                <v-toolbar
                        dark
                        color="primary"
                >
                    <v-toolbar-title>
                        <v-icon
                                right
                                dark
                        >
                            mdi-home-edit
                        </v-icon>
                        {{$t('validar_datos_vivienda')}}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                            class="align-self-end"
                            color="red"
                            icon
                            @click="dialogInfoResidenceRequest = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <v-window v-model="step">
                        <v-window-item :value="1">
                            <h2>{{$t('datos_vivienda')}}</h2>
                            <br>
                            <v-layout row wrap>
                                <v-flex xs12 sm6>
                                    <v-text-field
                                            class="pl-3 pr-3"
                                            :label="$t('nombre_calle')"
                                            :value="residenceRequestInfo.idHouse ? residenceRequestInfo.idHouse.street : ''"
                                            readonly
                                            outlined
                                    >
                                    </v-text-field>
                                </v-flex>
                                <v-flex xs12 sm3>
                                    <v-text-field
                                            class="pl-3 pr-3"
                                            :label="$t('numero_casa')"
                                            :value="residenceRequestInfo.idHouse ? residenceRequestInfo.idHouse.number : ''"
                                            readonly
                                            outlined
                                    >
                                    </v-text-field>
                                </v-flex>
                            </v-layout>
                            <br>
                            <v-divider></v-divider>
                            <br>
                            <h2>{{$t('datos_residente_principal')}}</h2>
                            <br>
                            <v-layout row wrap>
                                <v-flex
                                        class="pl-3 pr-3 pt-3 pb-3"
                                        xs12 sm6
                                >
                                    <v-img
                                            v-if="residenceRequestInfo.idUser.idFront"
                                            readonly
                                            outlined
                                            :src="residenceRequestInfo.idUser.idFront"
                                    ></v-img>
                                    <v-alert v-else type="info" outlined dense>
                                        {{$t('foto_no_disponible')}}
                                    </v-alert>
                                </v-flex>
                                <v-flex
                                        class="pl-3 pr-3 pt-3 pb-3"
                                        xs12 sm6
                                >
                                    <v-img
                                            v-if="residenceRequestInfo.idUser.idBack"
                                            readonly
                                            outlined
                                            :src="residenceRequestInfo.idUser.idBack"
                                    ></v-img>
                                    <v-alert v-else type="info" outlined dense>
                                        {{$t('foto_no_disponible')}}
                                    </v-alert>
                                </v-flex>
                            </v-layout>
                            <v-divider></v-divider>
                            <br>
                            <v-layout row wrap>
                                <v-flex xs12 sm6 md4>
                                    <v-text-field
                                            class="pl-3 pr-3"
                                            prepend-icon="mdi-account"
                                            :label="$t('Nombre')"
                                            :value="residenceRequestInfo.idUser.first_name"
                                            readonly
                                            outlined
                                    >
                                    </v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md4>
                                    <v-text-field
                                            class="pl-3 pr-3"
                                            prepend-icon="mdi-account-outline"
                                            :label="$t('Apellido')"
                                            :value="residenceRequestInfo.idUser.last_name"
                                            readonly
                                            outlined
                                    >
                                    </v-text-field>
                                </v-flex>
                                <v-flex xs12 sm6 md4>
                                    <v-text-field
                                            class="pl-3 pr-3"
                                            prepend-icon="mdi-email"
                                            label="E-Mail"
                                            :value="residenceRequestInfo.idUser.email"
                                            readonly
                                            outlined
                                    >
                                    </v-text-field>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex xs12 sm6 md4>
                                    <v-text-field
                                            class="pl-3 pr-3"
                                            prepend-icon="mdi-cellphone"
                                            :label="$t('celular')"
                                            :value="residenceRequestInfo.idUser.cellNumber"
                                            readonly
                                            outlined
                                    >
                                    </v-text-field>
                                </v-flex>
                            </v-layout>
                        </v-window-item>
                    </v-window>
                </v-card-text>
                <v-card-actions>
                    {{$t('msg_reconoce_residentes')}}
                    <v-radio-group
                            row
                            v-model="confirm"
                            name="confirm"
                            :mandatory="false"
                    >
                        <v-radio
                                class="pl-3 pr-3"
                                :label="$t('Si')"
                                value=true
                                outlined
                        ></v-radio>
                        <v-radio
                                class="pl-3 pr-3"
                                label="No"
                                value=false
                                outlined
                        ></v-radio>
                    </v-radio-group>
                    <v-flex v-if="confirm === 'false'">
                        <v-textarea
                            v-model="feedback"
                            outlined
                            :placeholder="$t('msg_additional_comments')"
                            :label="$t('additional_comments')">
                        </v-textarea>
                    </v-flex>
                    <v-btn
                            class="align-center"
                            color="primary"
                            large
                            :loading="loading"
                            @click="activateDeleteResidenceRequest()"
                    >
                        {{$t('enviar')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--    Diálogo Modal  Confirmar   -->
        <v-dialog v-model="dialogConfirm" max-width="290">
            <v-card>
                <v-card-title class="headline">{{$t('aviso')}}</v-card-title>
                <v-card-text align="center">
                    {{$t('msg_confirma_validacion_1')}} <b>{{$t('Si')}}</b> {{$t('or')}} <b> No </b> {{$t('msg_confirma_validacion_2')}}<br><br>
                    <v-btn color="primary" @click="dialogConfirm = false">{{$t('aceptar')}}</v-btn>
                </v-card-text>
            </v-card>
        </v-dialog>
        <!--    Diálogo Modal para mostrar a los Residente(s)    -->
        <v-dialog v-model="dialog_residente" scrollable max-width="400">
            <v-card>
                <v-toolbar dark  color="primary">
                    <v-toolbar-title>
                        {{$t('detalle_residente')}}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                            class="align-self-end"
                            icon
                            @click="dialog_residente = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text class="mt-5">
                    <v-layout row wrap>
                        <v-flex xs12>
                        <v-flex
                            class="pl-3 pr-3 pt-3 pb-3"
                            xs12
                        >
                            <div class="wrapper">
                                <v-img
                                        :src="editedItem.idUser.avatar"
                                ></v-img>
                            </div>
                        </v-flex>
                            <v-text-field
                                    class="pl-3 pr-3"
                                    prepend-icon="mdi-account"
                                    :label="$t('Nombre')"
                                    :value="editedItem.idUser.first_name"
                                    readonly
                                    outlined
                            >
                            </v-text-field>
                        </v-flex>
                        <v-flex xs12>
                            <v-text-field
                                    class="pl-3 pr-3"
                                    prepend-icon="mdi-account-outline"
                                    :label="$t('Apellido')"
                                    :value="editedItem.idUser.last_name"
                                    readonly
                                    outlined
                            >
                            </v-text-field>
                        </v-flex>
                        <v-flex xs12>
                            <v-text-field
                                    class="pl-3 pr-3"
                                    prepend-icon="mdi-cellphone"
                                    :label="$t('celular')"
                                    :value="editedItem.idUser.cellNumber"
                                    readonly
                                    outlined
                            ></v-text-field>
                        </v-flex>
                        <v-flex xs12>
                            <v-text-field
                                    class="pl-3 pr-3"
                                    prepend-icon="mdi-email"
                                    label="E-Mail"
                                    :value="editedItem.idUser.email"
                                    readonly
                                    outlined
                            ></v-text-field>
                        </v-flex>
<!--                        <v-flex xs12>-->
<!--                            <v-checkbox-->
<!--                                    class="pl-3 pr-3"-->
<!--                                    :label="$t('puede_enviar')"-->
<!--                                    v-model="editedItem.puede_enviar"-->
<!--                                    readonly-->
<!--                                    outlined-->
<!--                            ></v-checkbox>-->
<!--                        </v-flex>-->
                    </v-layout>
                </v-card-text>
            </v-card>
        </v-dialog>
        <!--    Diálogo  Modal para mostrar mensaje Número de Celular incorrecto    -->
        <v-dialog v-model="dialogCellNumberWrong" max-width="290">
            <v-card>
                <v-card-title class="headline">{{$t('aviso')}}</v-card-title>
                <v-card-text>{{$t('cellphone_wrong')}}</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="dialogCellNumberWrong = false">{{$t('aceptar')}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--    Diálogo Modal para mostrar mensaje No hay residentes secundarios registrados    -->
        <v-dialog v-model="dialogNoSecondaryResidents" max-width="290">
            <v-card>
                <v-card-title class="headline">{{$t('aviso')}}</v-card-title>
                <v-card-text>{{$t('msg_no_registered_secondary_residents_yet')}}</v-card-text>
                <v-card-actions>
                    <v-spacer></v-spacer>
                    <v-btn color="primary" @click="dialogNoSecondaryResidents = false">{{$t('aceptar')}}</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--    Diálogo  Modal para Cambiar Permisos (Usuario -> Residente Principal)    -->
        <v-dialog v-model="dialogMoveUp" max-width="500">
            <v-form @submit.prevent="moveUpUserToMainResident()">
                <v-card class="elevation-5">
                    <v-toolbar dark color="primary">
                        <v-toolbar-title>
                            {{$t('move_up_user_to_main_resident')}}
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn
                                class="align-self-end"
                                color="red"
                                icon
                                @click="dialogMoveUp = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-card-text>
                        <v-layout row wrap>
                            <v-autocomplete
                                    v-model="emailGuest"
                                    :items="items"
                                    prepend-icon="mdi-email"
                                    :loading="isLoading"
                                    :search-input.sync="search2"
                                    :item-text="example"
                                    item-value="id"
                                    :placeholder="$t('placeholder_invitados2')"
                                    :label="$t('usuarios')"
                                    :error-messages="errores.idUser"
                                    :no-data-text="$t('no_resultados')"
                                    clearable
                                    autocomplete="off"
                            >
                                <template v-slot:selection="data">
                                    <v-chip
                                            v-bind="data.attrs"
                                            :input-value="data.selected"
                                            @click="data.select"
                                    >
                                        <v-avatar left>
                                            <v-img :src="data.item.avatar"></v-img>
                                        </v-avatar>
                                        {{ data.item.first_name }} {{data.item.last_name}}
                                    </v-chip>
                                </template>
                                <template v-slot:item="data">
                                    <template v-if="typeof data.item !== 'object'">
                                        <v-list-item-content v-text="data.item"></v-list-item-content>
                                    </template>
                                    <template v-else>
                                        <v-list-item-avatar>
                                            <img :src="data.item.avatar">
                                        </v-list-item-avatar>
                                        <v-list-item-content>
                                            <v-list-item-title>{{ data.item.first_name }} {{data.item.last_name}}</v-list-item-title>
                                            <v-list-item-sub-title v-html="data.item.group"></v-list-item-sub-title>
                                        </v-list-item-content>
                                    </template>
                                </template>
                            </v-autocomplete>
                            <v-autocomplete
                                    v-model="id_house"
                                    prepend-icon="mdi-home"
                                    name="id_house"
                                    :item-text="example2"
                                    item-value="id"
                                    :label="$t('casas')"
                                    :placeholder="$t('search_by_house_number')"
                                    :filter="customFilter"
                                    :error-messages="errores.idHouse"
                                    :items="houses"
                                    no-data-text="Ningún Resultado"
                                    clearable
                                    autocomplete="off"
                            >
                                <template v-slot:item="data">
                                    <strong>{{data.item.street === null ? 'n/a' : data.item.street}} {{data.item.number === null ? 'n/a' : data.item.number}} ( {{data.item.phone === null ? 'n/a' : data.item.phone}} )</strong>
                                </template>
                            </v-autocomplete>
                        </v-layout>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn
                                color="primary"
                                @click="dialogMoveUp = false"
                        >
                            {{$t('cerrar')}}
                        </v-btn>
                        <v-spacer/>
                        <v-btn
                                color="primary"
                                type="submit"
                                :loading="loading"
                        >
                            {{$t('modificar')}}
                            <v-icon dark right>mdi-swap-horizontal</v-icon>
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>
        <!--    Diálogo  Modal para Actualizar Códigos de Residentes Periódicamente    -->
        <v-dialog v-model="dialogUpdateQRCodes" max-width="500">
            <v-form @submit.prevent="updateQRCodes()">
                <v-card class="elevation-5">
                    <v-toolbar dark color="primary">
                        <v-toolbar-title>
                            {{$t('renovar_codigos_residentes')}}
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn
                                class="align-self-end"
                                color="red"
                                icon
                                @click="dialogUpdateQRCodes = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-card-text class="text-center">
                        <p>
                            {{$t('msg_update_code_1')}}
                            <br><br>
                            {{$t('msg_update_code_2')}}
                        </p>
                        <v-layout align-center justify-center fill-height>
                            <v-switch
                                    v-model="QRCodes"
                                    :label="$t('allow')">
                            </v-switch>
                        </v-layout>
                    </v-card-text>
                    <v-card-actions>
                        <v-btn
                                color="primary"
                                @click="dialogUpdateQRCodes = false"
                        >
                            {{$t('cerrar')}}
                        </v-btn>
                        <v-spacer/>
                        <v-btn
                                color="primary"
                                type="submit"
                                :loading="loadingQRCodes"
                        >
                            {{$t('modificar')}}
                            <v-icon dark right>mdi-calendar-clock</v-icon>
                        </v-btn>
                    </v-card-actions>
                </v-card>
            </v-form>
        </v-dialog>
        <!--    Diálogo  Modal para Actualizar Códigos de Residentes Periódicamente    -->
        <v-dialog v-model="dialogAllResidents" max-width="1200">
              <v-card class="elevation-5">
                    <v-toolbar dark color="primary">
                        <v-toolbar-title>
                            {{this.fullname_axu === '' ? $t('residentes') : ''}} {{this.fullname_axu !== '' ? $t('residente_principal') + ': ' + this.fullname_axu + ', ' : ''}} {{this.address_aux !== '' ? $t('direccion') + ': ' + this.address_aux : ''}}
                        </v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-btn
                                class="align-self-end"
                                color="red"
                                icon
                                @click="dialogAllResidents = false">
                            <v-icon>mdi-close</v-icon>
                        </v-btn>
                    </v-toolbar>
                    <v-card-text class="text-center">
                        <v-card-title>
                            <v-text-field
                                    v-model="searchAllResidents"
                                    clearable
                                    append-icon="mdi-account-search"
                                    :label="$t('Buscar')"
                                    single-line
                                    hide-details
                            ></v-text-field>
                        </v-card-title>
                        <v-data-table
                                :headers="getProfile.enable_biometric === true ? headersAllResidents: headersAllResidents2"
                                :loading="loadingDataAllResidents"
                                :items="allResidents"
                                multi-sort
                                :search="searchAllResidents"
                                :footer-props="{
                                    itemsPerPageOptions: [
                                        {text: '10', value: 10}
                                    ],
                                    itemsPerPageText: $t('filas_por_pagina')
                                }"
                                class="elevation-1"
                                :no-data-text="$t('no_records_yet')"
                        >
                            <template v-slot:item.action="{ item }">
                                <v-tooltip bottom>
                                    <template v-slot:activator="{ on, attrs }">
                                        <v-icon
                                                v-if="item.temporalToken === ''"
                                                v-bind="attrs"
                                                v-on="on"
                                                medium
                                                color="gray"
                                                class="mr-2"
                                                @click="fillFields(item), update = true, dialogDataResident = true, id_update = item.id"
                                        >
                                            mdi-magnify
                                        </v-icon>
                                    </template>
                                    <span>{{$t('show_details')}}</span>
                                </v-tooltip>
                            </template>
                            <template v-slot:item.principal="{ item }">
                              <div v-if="item.principal">
                                <strong>Principal</strong>
                              </div>
                              <div v-else>
                                Secundario
                              </div>
                            </template>
                            <template v-slot:item.fullname="{ item }">
                              <div v-if="item.principal">
                                <strong>{{item.fullname}}</strong>
                              </div>
                              <div v-else>
                                <div v-if="item.fullname === ' '">
                                  {{$t('pendiente')}}
                                </div>
                                <div v-else>
                                {{item.fullname}}
                                </div>
                              </div>
                            </template>
                            <template v-slot:item.address="{ item }">
                              <div v-if="item.principal">
                                <strong>{{item.address}}</strong>
                              </div>
                              <div v-else>
                                {{item.address}}
                              </div>
                            </template>
                            <template v-slot:item.idUser.cellNumber="{ item }">
                              <div v-if="item.principal">
                                <strong>{{item.idUser.cellNumber}}</strong>
                              </div>
                              <div v-else>
                                {{item.idUser.cellNumber}}
                              </div>
                            </template>
                            <template v-slot:item.idUser.email="{ item }">
                              <div v-if="item.principal">
                                <strong>{{item.idUser.email}}</strong>
                              </div>
                              <div v-else>
                                {{item.idUser.email}}
                              </div>
                            </template>
                            <template v-slot:no-results>
                                <v-alert type="warning">
                                    {{$t('ningun_resultado_1')}} "{{ searchAllResidents }}" {{$t('ningun_resultado_2')}}
                                </v-alert>
                            </template>
                        </v-data-table>
                    </v-card-text>
              </v-card>
        </v-dialog>
        <!--    Diálogo Modal para mostrar informacion del Residente    -->
        <v-dialog v-model="dialogDataResident" scrollable max-width="600px">
                <v-form @submit.prevent="update
                                        ? updateResident(id_update)
                                        : createMainResident()">
                    <v-card class="elevation-5">
                        <v-toolbar dark color="primary">
                            <v-toolbar-title>
                                {{ $t('residente') }}
                            </v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn
                                    class="align-self-end"
                                    color="red"
                                    icon
                                    @click="clear(), dialogDataResident = false">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </v-toolbar>
                        <v-card-text>
                            <v-autocomplete
                                    v-if="update === false"
                                    v-model="id_house"
                                    prepend-icon="mdi-home-city"
                                    name="id_house"
                                    :item-text="example2"
                                    item-value="id"
                                    :label="$t('casas')"
                                    :placeholder="$t('search_by_house_number')"
                                    :filter="customFilter"
                                    :error-messages="errores.idHouse"
                                    :items="houses"
                                    no-data-text="Ningún Resultado"
                                    clearable
                            >
                                <template v-slot:item="data">
                                    <strong>{{data.item.street === null ? 'n/a' : data.item.street}} {{data.item.number === null ? 'n/a' : data.item.number}} ( {{data.item.phone === null ? 'n/a' : data.item.phone}} )</strong>
                                </template>
                            </v-autocomplete>
                            <v-text-field
                                    readonly
                                    v-model="first_name"
                                    prepend-icon="mdi-account"
                                    name="first_name"
                                    :label="$t('Nombre')"
                                    :error-messages="errores_seg.first_name"
                            >
                            </v-text-field>
                            <v-text-field
                                    readonly
                                    v-model="last_name"
                                    prepend-icon="mdi-account-outline"
                                    name="last_name"
                                    :label="$t('Apellido')"
                                    :error-messages="errores_seg.last_name"
                            >
                            </v-text-field>
                            <v-text-field
                                  v-show="getProfile.enable_biometric"
                                    v-model="payroll_number"
                                    prepend-icon="mdi-numeric"
                                    name="payroll_number"
                                    :label="$t('payroll_number')"
                                    :error-messages="errores.payroll_number"
                              >
                            </v-text-field>
                            <v-layout row wrap>
                                <v-flex xs12 sm6 class="edge pt-3 pb-3 pl-3 pr-3">
                                    <v-label>
                                        {{$t('foto_ine')}}<br>[{{$t('frente')}}]
                                    </v-label>
                                    <br>
                                    <v-img
                                            class="pt-3 pb-3"
                                            :src="resultFrontURL"
                                            v-if="resultFrontURL"
                                            width="auto"
                                            height="180"
                                    ></v-img>
                                    <br>
                                    <v-alert
                                            v-if="errores_seg.idFront"
                                            type="error"
                                            outlined
                                            transition="scale-transition"
                                    >
                                        {{errores_seg.idFront}}
                                    </v-alert>
                                </v-flex>
                                <v-flex xs12 sm6 class="edge pt-3 pb-3 pl-3 pr-3">
                                    <v-label>
                                        {{$t('foto_ine')}}<br>[{{$t('atras')}}]
                                    </v-label>
                                    <br>
                                    <v-img
                                            class="pt-3 pb-3"
                                            :src="resultBackURL"
                                            v-if="resultBackURL"
                                            width="auto"
                                            height="180"
                                    ></v-img>
                                    <br>
                                    <v-alert
                                            v-if="errores_seg.idBack"
                                            type="error"
                                            outlined
                                            transition="scale-transition"
                                    >
                                        {{errores_seg.idBack}}
                                    </v-alert>
                                </v-flex>
                            </v-layout>
                            <v-layout row wrap>
                                <v-flex xs12 sm6 class="edge pt-3 pb-3 pl-3 pr-3">
                                    <div class="splash-info">
                                        <v-label>
                                            {{$t('foto_perfil')}}
                                        </v-label>
                                        <br>
                                        <div class="wrapper">
                                            <img
                                                    :src="resultProfileURL"
                                                    v-if="resultProfileURL">
                                        </div>
                                        <br>
                                        <v-alert
                                                v-if="errores_seg.avatar"
                                                type="error"
                                                outlined
                                                transition="scale-transition"
                                        >
                                            {{errores_seg.avatar}}
                                        </v-alert>
                                    </div>
                                </v-flex>
                                <v-flex xs12 sm6 md6 lg6 xl6>
                                    <div class="ml-3 mt-5">
                                      {{$t('renting_house')}}
                                    </div>
                                    <v-checkbox
                                            readonly
                                            class="ml-3"
                                            v-model="rented_house"
                                            name="rented_house"
                                            :label="$t('rented_house')"
                                            :error-messages="errores.rented_house"
                                    ></v-checkbox>
                                </v-flex>
                            </v-layout>
                            <vue-tel-input
                                    class="mt-3 mb-3"
                                    v-model="celular"
                                    @onInput="onInput"
                            >
                                <v-alert v-if="errores_seg.cellNumber" type="error">{{errores_seg.cellNumber}}</v-alert>
                            </vue-tel-input>
                            <v-alert outlined v-if="errores_seg.cellNumber" type="error">{{errores_seg.cellNumber}}</v-alert>
                            <v-layout row wrap>
                                <v-flex xs12>
                                    <v-text-field
                                            readonly
                                            autocomplete="username"
                                            v-model="email"
                                            prepend-icon="mdi-email"
                                            name="email"
                                            label="E-Mail"
                                            :error-messages="errores_seg.email"
                                    >
                                    </v-text-field>
                                </v-flex>
                            </v-layout>
<!--                            <v-checkbox-->
<!--                                    v-model="change_password"-->
<!--                                    v-if="update" disable-->
<!--                                    name="change_password"-->
<!--                                    label="Cambiar Contraseña"-->
<!--                            ></v-checkbox>-->
                            <ValidationObserver>
                                <ValidationProvider :rules="change_password ? 'required|password:@confirm' : ''" v-slot="{ errors }">
                                    <v-text-field
                                            v-show="!update"
                                            autocomplete="new-password"
                                            v-model="password"
                                            :disabled="update && !change_password ? true: false"
                                            prepend-icon="mdi-lock"
                                            :label="$t('password')"
                                            :type="show ? 'text' : 'password'"
                                            :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                                            @click:append="show = !show"
                                            :error-messages="change_password ? errores_seg.password : ''">
                                    </v-text-field>
                                    <span>{{ errors[0] }}</span>
                                </ValidationProvider>
                                <ValidationProvider name="confirm" :rules="change_password ? 'required' : ''" v-slot="{ errors }">
                                    <v-text-field
                                            v-show="!update"
                                            autocomplete="new-password"
                                            v-model="confirmation"
                                            :disabled="update  && !change_password ? true: false"
                                            prepend-icon="mdi-lock"
                                            :label="$t('password_confirm')"
                                            :type="show ? 'text' : 'password'"
                                            :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                                            @click:append="show = !show">
                                    </v-text-field>
                                    <span>{{ errors[0] }}</span>
                                </ValidationProvider>
                            </ValidationObserver>
                            <v-alert
                                    :value=alerta
                                    type="warning"
                                    outlined
                                    transition="scale-transition"
                            >
                                Fallo con el Servidor
                            </v-alert>
                        </v-card-text>
                        <v-card-actions v-show="getProfile.enable_biometric">
                            <v-btn
                                    color="primary"
                                    @click="clear(),
                                    dialogDataResident = false"
                            >{{$t('cerrar')}}
                            </v-btn>
                            <v-spacer/>
                            <v-btn
                                    v-if="update"
                                    :loading="loading"
                                    color="primary"
                                    type="submit"
                            >{{$t('modificar')}}
                            </v-btn>
                            <v-btn
                                    v-else
                                    :loading="loading"
                                    color="primary"
                                    type="submit"
                            >{{$t('agregar')}}
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-form>
            </v-dialog>
        <!--   Diálogo para Mostrar un mensaje al Eliminar Residente Principal     -->
        <v-dialog
                v-model="deleteDialog"
                max-width="450"
        >
            <v-card>
                <v-card-title class="headline">
                    {{$t('msg_delete_main_resident')}}
                </v-card-title>

                <v-card-text>
                    {{$t('msg_accion_deshacer')}}
                </v-card-text>
                <v-card-actions>
                    <v-btn
                            color="primary"
                            @click="deleteDialog = false"
                    >
                        No
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                            color="primary"
                            @click="deleteMainResident()"
                    >
                        {{$t('Si')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--   Diálogo para Mostrar un mensaje Time Unlock     -->
        <v-dialog
                v-model="dialogTimeUnlock"
                max-width="300px"
        >
            <v-card>
                <v-card-title class="headline">
                    Error
                </v-card-title>
                <v-card-text>
                    {{$t('msg_time_unlock')}}
                </v-card-text>
                <v-card-actions class='justify-center'>
                    <v-btn
                            color="primary"
                            @click="dialogTimeUnlock = false"
                    >
                        {{ $t('aceptar') }}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--   Diálogo para mostrar un mensaje al Bloquear/Reactivar Residente Principal por morosidad     -->
        <v-dialog
                v-model="dialogDefaulter"
                max-width="650"
        >
            <v-card>
                <v-toolbar dark :color=" enable === false ? 'primary' : 'warning'">
                    <v-toolbar-title>
                        {{$t('aviso')}}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                            class="align-self-end"
                            color="red"
                            icon
                            @click="dialogDefaulter = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-title class="headline">
                    <div v-if="enable === false">
                        {{$t('msg_unlock_main_resident')}}
                    </div>
                    <div v-else-if="disable=== false">
                        {{$t('msg_block_main_resident')}}
                    </div>
                </v-card-title>
                <v-card-text v-if="enable === false">
                    {{$t('note_unlock_main_resident')}}
                </v-card-text>
                <v-card-text v-else-if="disable === false">
                    {{$t('note_block_main_resident')}}<br><br>
                    <strong>{{$t('note2_block_main_resident')}}</strong>
                </v-card-text>
                <v-card-actions>
                    <v-btn
                            outlined
                            color="black"
                            @click="dialogDefaulter = false"
                    >
                        No
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                            outlined
                            color="black"
                            @click="blockReactivateResidentsDefaulter()"
                    >
                        {{$t('Si')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--   Diálogo para Mostrar un mensaje al Activar/Desactivar Residente Principal     -->
        <v-dialog
                v-model="dialogEnableDisable"
                max-width="600"
        >
            <v-card>
                <v-toolbar dark :color=" enable === true ? 'primary' : 'warning'">
                    <v-toolbar-title>
                        {{$t('aviso')}}
                    </v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn
                            class="align-self-end"
                            color="red"
                            icon
                            @click="dialogEnableDisable = false">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-title class="headline">
                    <div v-if="enable === true">
                        {{$t('msg_enable_main_resident')}}
                    </div>
                    <div v-else-if="disable=== true">
                        {{$t('msg_disable_main_resident')}}
                    </div>
                </v-card-title>
                <v-card-text v-if="enable === true">
                    {{$t('note_enable_main_resident')}}
                </v-card-text>
                <v-card-text v-else-if="disable === true">
                    {{$t('note_disable_main_resident')}}
                </v-card-text>
                <v-card-actions>
                    <v-btn
                            outlined
                            color="black"
                            @click="dialogEnableDisable = false"
                    >
                        No
                    </v-btn>
                    <v-spacer></v-spacer>
                    <v-btn
                            outlined
                            color="black"
                            @click="enableDisableMainResident()"
                    >
                        {{$t('Si')}}
                    </v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--     Diálogo Modal Persistente para Recortar la Imagen Identificacón Oficial Frontal      -->
        <v-dialog v-model="dialogImageFront" persistent scrollable max-width="800px">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>
                        {{$t('recortar_imagen')}}
                    </v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <clipper-fixed
                            :rotate="degrees"
                            :ratio="ratio"
                            ref="clipperImageFront"
                            :src="imageFrontURL">
                    </clipper-fixed>
                </v-card-text>
                <v-card-actions class="justify-center"> <v-col>
                    <v-row xs12 class="justify-center">
                        <v-radio-group
                                v-model="ratio"
                                name="ratio"
                                row
                                label="Ratio"
                                :mandatory="false"
                        >
                            <v-radio label="1:1" value="1"></v-radio>
                            <v-radio label="3:2" value="1.5"></v-radio>
                            <v-radio label="4:3" value="1.3333333333333333"></v-radio>
                            <v-radio label="16:9" value="1.7777777777777777"></v-radio>
                        </v-radio-group>
                    </v-row>
                    <v-row xs12 class="justify-center mr-6">
                        <v-slider
                                v-model="degrees"
                                :label="$t('grados')"
                                step="1"
                                max="180"
                                min="-180"
                                thumb-label="always"
                        ></v-slider>
                    </v-row>
                    <v-row class="justify-center">
                        <v-btn
                                color="primary"
                                @click="getCutingFront()"
                        >{{$t('recortar')}}</v-btn>
                    </v-row>
                </v-col>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--     Diálogo Modal Persistente para Recortar la Imagen Identificacón Oficial Atrás      -->
        <v-dialog v-model="dialogImageBack" persistent scrollable max-width="800px">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>
                        {{$t('recortar_imagen')}}
                    </v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <clipper-fixed
                            :rotate="degrees"
                            :ratio="ratio"
                            ref="clipperImageBack"
                            :src="imageBackURL">
                    </clipper-fixed>
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-col>
                        <v-row xs12 class="justify-center">
                            <v-radio-group
                                    v-model="ratio"
                                    name="ratio"
                                    row
                                    label="Ratio"
                                    :mandatory="false"
                            >
                                <v-radio label="1:1" value="1"></v-radio>
                                <v-radio label="3:2" value="1.5"></v-radio>
                                <v-radio label="4:3" value="1.3333333333333333"></v-radio>
                                <v-radio label="16:9" value="1.7777777777777777"></v-radio>
                            </v-radio-group>
                        </v-row>
                        <v-row xs12 class="justify-center mr-6">
                            <v-slider
                                    v-model="degrees"
                                    :label="$t('grados')"
                                    step="1"
                                    max="180"
                                    min="-180"
                                    thumb-label="always"
                            ></v-slider>
                        </v-row>
                        <v-row xs12 class="justify-center">
                            <v-btn
                                    color="primary"
                                    @click="getCutingBack()"
                            >{{$t('recortar')}}</v-btn>
                        </v-row>
                    </v-col>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <!--     Diálogo Modal Persistente para Recortar la Foto de perfil      -->
        <v-dialog v-model="dialogImageProfile" persistent scrollable max-width="800px">
            <v-card>
                <v-toolbar dark color="primary">
                    <v-toolbar-title>
                        {{$t('recortar_imagen')}}
                    </v-toolbar-title>
                </v-toolbar>
                <v-card-text>
                    <clipper-fixed
                            class="basic lg"
                            :src="imageProfileURL"
                            ref="clipperImageProfile"
                            :rotate="degrees"
                            :round="true"
                            preview="preview">
                    </clipper-fixed>
                </v-card-text>
                <v-card-actions class="justify-center">
                    <v-col>
                        <v-row xs12 class="justify-center mr-6">
                            <v-slider
                                    v-model="degrees"
                                    :label="$t('grados')"
                                    step="1"
                                    max="180"
                                    min="-180"
                                    thumb-label="always"
                            ></v-slider>
                        </v-row>
                        <v-row xs12 class="justify-center">
                            <v-btn
                                    color="primary"
                                    @click="getCutingProfile()"
                            >{{$t('recortar')}}</v-btn>
                        </v-row>
                    </v-col>
                </v-card-actions>
            </v-card>
        </v-dialog>
        <h2 class="subheading grey--text">{{ $t('main_residents') }}</h2>
        <v-layout align-center justify-center fill-height>
            <v-dialog v-model="dialog" persistent scrollable max-width="720px">
                <template v-slot:activator="{ on }">
                    <v-layout row wrap class="justify-center">
                        <v-btn
                                color="primary"
                                dark
                                v-on="on"
                                @click="update = false,
                                cleanFields(), getHouses()"> + {{ $t('anadir_main_resident') }}
                        </v-btn>
                        <v-btn
                                arrow_upward
                                color="primary"
                                @click="dialogMoveUp = true, getHouses(), emailGuest = '', id_house = '', entries = [], errores = [] "
                        >
                            <v-icon dark left>mdi-swap-horizontal</v-icon>
                            {{$t('cambiar_permisos')}}
                        </v-btn>
                        <v-btn
                                color="primary"
                                @click="getStatusUpdateQRCode(), dialogUpdateQRCodes = true"
                        >
                            <v-icon dark left>mdi-calendar-clock</v-icon>
                            {{$t('renovar_codigos')}}
                        </v-btn>
                        <v-btn v-show="getProfile.is_fanvil_device" color="info" @click="syncResidentsToMiddleware()" :loading="loadingSync">
                          <v-icon dark left>mdi-cloud-sync</v-icon>
                          {{ $t('sincronizar') }}
                        </v-btn>
                        <v-btn
                                color="primary"
                                :loading="loadingDataAllResidents"
                                @click="getAllResidents()"
                        >
                            <v-icon dark left>mdi-account-star</v-icon>
                            {{$t('show_all_residents')}}
                        </v-btn>
                    </v-layout>
                </template>
                <v-form @submit.prevent="update
                                        ? updateMainResident(id_update)
                                        : createMainResident()">
                    <v-card class="elevation-5">
                        <v-toolbar dark color="primary" flat>
                            <v-avatar size="40" color="white" class="mr-3">
                                <v-img v-if="resultProfileURL" :src="resultProfileURL"></v-img>
                                <v-icon v-else color="primary">mdi-account-star</v-icon>
                            </v-avatar>
                            <div>
                                <v-toolbar-title>{{ $t('residente_principal') }}</v-toolbar-title>
                                <div v-if="update && (first_name || last_name)" class="caption">
                                    {{ first_name }} {{ last_name }}
                                </div>
                            </div>
                            <v-spacer></v-spacer>
                            <v-btn
                                    class="align-self-end"
                                    icon
                                    @click="clear(), dialog = false">
                                <v-icon>mdi-close</v-icon>
                            </v-btn>
                        </v-toolbar>
                        <v-card-text class="pt-5">
                            <!--  Datos personales  -->
                            <div class="mr-section-title">
                                <v-icon small left color="primary">mdi-account</v-icon>
                                {{ $t('mr_personal_data') }}
                            </div>
                            <v-row dense>
                                <v-col cols="12" sm="6">
                                    <v-text-field
                                            v-model="first_name"
                                            outlined
                                            dense
                                            name="first_name"
                                            :label="$t('Nombre')"
                                            :error-messages="errores_seg.first_name"
                                    ></v-text-field>
                                </v-col>
                                <v-col cols="12" sm="6">
                                    <v-text-field
                                            v-model="last_name"
                                            outlined
                                            dense
                                            name="last_name"
                                            :label="$t('Apellido')"
                                            :error-messages="errores_seg.last_name"
                                    ></v-text-field>
                                </v-col>
                                <v-col v-show="getProfile.enable_biometric" cols="12" sm="6">
                                    <v-text-field
                                            v-model="payroll_number"
                                            outlined
                                            dense
                                            prepend-inner-icon="mdi-numeric"
                                            name="payroll_number"
                                            :label="$t('payroll_number')"
                                            :error-messages="errores.payroll_number"
                                    ></v-text-field>
                                </v-col>
                            </v-row>
                            <v-divider class="my-4"></v-divider>

                            <!--  Contacto  -->
                            <div class="mr-section-title">
                                <v-icon small left color="primary">mdi-card-account-phone</v-icon>
                                {{ $t('mr_contact') }}
                            </div>
                            <v-row dense>
                                <v-col cols="12" sm="6">
                                    <vue-tel-input
                                            v-model="celular"
                                            @onInput="onInput"
                                    ></vue-tel-input>
                                    <v-alert
                                            v-if="errores_seg.cellNumber"
                                            class="mt-2 mb-0"
                                            type="error"
                                            outlined
                                            dense
                                    >{{ errores_seg.cellNumber }}</v-alert>
                                </v-col>
                                <v-col cols="12" sm="6">
                                    <v-text-field
                                            v-model="email"
                                            outlined
                                            dense
                                            autocomplete="username"
                                            prepend-inner-icon="mdi-email"
                                            name="email"
                                            label="E-Mail"
                                            :error-messages="errores_seg.email"
                                    ></v-text-field>
                                </v-col>
                                <v-col v-if="update && getProfile.idHousingUnit === '4ffccfe3-0062-444d-aaab-df1e65cf9222'" cols="12">
                                    <v-btn
                                            block
                                            outlined
                                            color="green"
                                            :loading="loading_send_email"
                                            @click="sendEmail(id_update)"
                                    >
                                        <v-icon left>mdi-email</v-icon>
                                        {{ $t('send_email_update') }}
                                    </v-btn>
                                </v-col>
                            </v-row>
                            <v-divider class="my-4"></v-divider>

                            <!--  Vivienda y permisos  -->
                            <div class="mr-section-title">
                                <v-icon small left color="primary">mdi-home-city</v-icon>
                                {{ $t('mr_housing_permissions') }}
                            </div>
                            <v-autocomplete
                                    v-if="update === false"
                                    v-model="id_house"
                                    outlined
                                    dense
                                    prepend-inner-icon="mdi-home-city"
                                    name="id_house"
                                    :item-text="example2"
                                    item-value="id"
                                    :label="$t('casas')"
                                    :placeholder="$t('search_by_house_number')"
                                    :filter="customFilter"
                                    :error-messages="errores.idHouse"
                                    :items="houses"
                                    no-data-text="Ningún Resultado"
                                    clearable
                            >
                                <template v-slot:item="data">
                                    <strong>{{data.item.street === null ? 'n/a' : data.item.street}} {{data.item.number === null ? 'n/a' : data.item.number}} ( {{data.item.phone === null ? 'n/a' : data.item.phone}} )</strong>
                                </template>
                            </v-autocomplete>
                            <v-card outlined class="mr-permission px-4 py-2 mb-3">
                                <v-switch
                                        v-model="rented_house"
                                        inset
                                        class="mt-1"
                                        name="rented_house"
                                        :label="$t('rented_house')"
                                        :hint="$t('renting_house')"
                                        persistent-hint
                                        :error-messages="errores.rented_house"
                                ></v-switch>
                            </v-card>
                            <v-card v-if="update" outlined class="mr-permission px-4 py-2">
                                <v-switch
                                        v-model="is_director"
                                        inset
                                        class="mt-1"
                                        name="is_director"
                                        :label="$t('mr_is_director')"
                                        :hint="$t('mr_is_director_hint')"
                                        persistent-hint
                                        :error-messages="errores.is_director"
                                ></v-switch>
                            </v-card>
                            <v-divider class="my-4"></v-divider>

                            <!--  Documentos  -->
                            <div class="mr-section-title">
                                <v-icon small left color="primary">mdi-file-image</v-icon>
                                {{ $t('mr_documents') }}
                            </div>
                            <div class="caption grey--text mb-3">{{ $t('foto_ine') }}</div>
                            <v-row dense>
                                <v-col cols="12" sm="4">
                                    <v-card outlined class="pa-3 text-center">
                                        <div class="caption font-weight-medium mb-2">{{ $t('frente') }}</div>
                                        <v-img
                                                v-if="resultFrontURL"
                                                class="mr-doc mb-3"
                                                :src="resultFrontURL"
                                                height="110"
                                                contain
                                        ></v-img>
                                        <div v-else class="mr-doc mr-doc-empty mb-3">
                                            <v-icon large color="grey lighten-1">mdi-card-account-details-outline</v-icon>
                                        </div>
                                        <v-btn small outlined block color="primary">
                                            <clipper-upload
                                                    @input="dialog = false, dialogImageFront = true, degrees = 0, ratio = '1'"
                                                    accept="image/*"
                                                    v-model="imageFrontURL"
                                            >
                                                {{ $t('subir_imagen') }}
                                            </clipper-upload>
                                        </v-btn>
                                        <v-alert
                                                v-if="errores_seg.idFront"
                                                class="mt-2 mb-0 caption"
                                                type="error"
                                                outlined
                                                dense
                                        >{{ errores_seg.idFront }}</v-alert>
                                    </v-card>
                                </v-col>
                                <v-col cols="12" sm="4">
                                    <v-card outlined class="pa-3 text-center">
                                        <div class="caption font-weight-medium mb-2">{{ $t('atras') }}</div>
                                        <v-img
                                                v-if="resultBackURL"
                                                class="mr-doc mb-3"
                                                :src="resultBackURL"
                                                height="110"
                                                contain
                                        ></v-img>
                                        <div v-else class="mr-doc mr-doc-empty mb-3">
                                            <v-icon large color="grey lighten-1">mdi-card-account-details-outline</v-icon>
                                        </div>
                                        <v-btn small outlined block color="primary">
                                            <clipper-upload
                                                    @input="dialog = false, dialogImageBack = true, degrees = 0, ratio = '1'"
                                                    accept="image/*"
                                                    v-model="imageBackURL"
                                            >
                                                {{ $t('subir_imagen') }}
                                            </clipper-upload>
                                        </v-btn>
                                        <v-alert
                                                v-if="errores_seg.idBack"
                                                class="mt-2 mb-0 caption"
                                                type="error"
                                                outlined
                                                dense
                                        >{{ errores_seg.idBack }}</v-alert>
                                    </v-card>
                                </v-col>
                                <v-col cols="12" sm="4">
                                    <v-card outlined class="pa-3 text-center">
                                        <div class="caption font-weight-medium mb-2">{{ $t('foto_perfil') }}</div>
                                        <div class="mr-doc d-flex align-center justify-center mb-3">
                                            <v-avatar size="110" color="grey lighten-4">
                                                <img v-if="resultProfileURL" :src="resultProfileURL">
                                                <v-icon v-else large color="grey lighten-1">mdi-account</v-icon>
                                            </v-avatar>
                                        </div>
                                        <v-btn small outlined block color="primary">
                                            <clipper-upload
                                                    @input="dialog = false, dialogImageProfile = true, degrees = 0, ratio = '1'"
                                                    accept="image/*"
                                                    v-model="imageProfileURL"
                                            >
                                                {{ $t('subir_imagen') }}
                                            </clipper-upload>
                                        </v-btn>
                                        <v-alert
                                                v-if="errores_seg.avatar"
                                                class="mt-2 mb-0 caption"
                                                type="error"
                                                outlined
                                                dense
                                        >{{ errores_seg.avatar }}</v-alert>
                                    </v-card>
                                </v-col>
                            </v-row>

                            <!--  Acceso (solo al crear)  -->
                            <div v-show="!update">
                                <v-divider class="my-4"></v-divider>
                                <div class="mr-section-title">
                                    <v-icon small left color="primary">mdi-lock</v-icon>
                                    {{ $t('mr_access') }}
                                </div>
                                <ValidationObserver>
                                    <v-row dense>
                                        <v-col cols="12" sm="6">
                                            <ValidationProvider :rules="change_password ? 'required|password:@confirm' : ''" v-slot="{ errors }">
                                                <v-text-field
                                                        v-model="password"
                                                        outlined
                                                        dense
                                                        autocomplete="new-password"
                                                        :disabled="update && !change_password ? true: false"
                                                        prepend-inner-icon="mdi-lock"
                                                        :label="$t('password')"
                                                        :type="show ? 'text' : 'password'"
                                                        :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                                                        @click:append="show = !show"
                                                        :error-messages="change_password ? errores_seg.password : ''">
                                                </v-text-field>
                                                <span class="caption error--text">{{ errors[0] }}</span>
                                            </ValidationProvider>
                                        </v-col>
                                        <v-col cols="12" sm="6">
                                            <ValidationProvider name="confirm" :rules="change_password ? 'required' : ''" v-slot="{ errors }">
                                                <v-text-field
                                                        v-model="confirmation"
                                                        outlined
                                                        dense
                                                        autocomplete="new-password"
                                                        :disabled="update  && !change_password ? true: false"
                                                        prepend-inner-icon="mdi-lock-check"
                                                        :label="$t('password_confirm')"
                                                        :type="show ? 'text' : 'password'"
                                                        :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                                                        @click:append="show = !show">
                                                </v-text-field>
                                                <span class="caption error--text">{{ errors[0] }}</span>
                                            </ValidationProvider>
                                        </v-col>
                                    </v-row>
                                </ValidationObserver>
                            </div>
                            <v-alert
                                    class="mt-4 mb-0"
                                    :value=alerta
                                    type="warning"
                                    outlined
                                    dense
                                    transition="scale-transition"
                            >
                                Fallo con el Servidor
                            </v-alert>
                        </v-card-text>
                        <v-divider></v-divider>
                        <v-card-actions class="px-4 py-3">
                            <v-btn
                                    text
                                    color="primary"
                                    @click="clear(),
                                            dialog = false"
                            >{{$t('cerrar')}}
                            </v-btn>
                            <v-spacer/>
                            <v-btn
                                    v-if="update"
                                    :loading="loading"
                                    color="primary"
                                    type="submit"
                            >
                                <v-icon left>mdi-content-save</v-icon>
                                {{$t('modificar')}}
                            </v-btn>
                            <v-btn
                                    v-else
                                    :loading="loading"
                                    color="primary"
                                    type="submit"
                            >
                                <v-icon left>mdi-plus</v-icon>
                                {{$t('agregar')}}
                            </v-btn>
                        </v-card-actions>
                    </v-card>
                </v-form>
            </v-dialog>
        </v-layout>
        <br>
        <v-tabs
                grow
                background-color="green"
                dark
        >
            <v-tab>
                <v-icon left>mdi-account-star</v-icon>
                {{$t('main_residents')}}
            </v-tab>
<!--            <v-tab>-->
<!--                <v-icon left>mdi-account-star</v-icon>-->
<!--                {{$t('main_residents')}} (APP)-->
<!--            </v-tab>-->
            <v-tab-item>
                <v-card flat>
                    <v-card-text>
                        <v-layout class="my-4" align-center justify-center fill-height>
                            <v-flex >
                                <v-card-title>
                                    <v-spacer></v-spacer>
                                    <v-text-field
                                            v-model="search"
                                            append-icon="mdi-account-search"
                                            :label="$t('Buscar')"
                                            single-line
                                            hide-details
                                            clearable
                                    ></v-text-field>
                                </v-card-title>
                                <v-data-table
                                        :headers="getProfile.enable_biometric === true ? headers : headers2"
                                        :loading="loadingDataMainResidents"
                                        :items="tableMainResidents"
                                        :search="search"
                                        :footer-props="{
                                            itemsPerPageOptions: [
                                                {text: '10', value: 10},
                                                {text: '20', value: 20},
                                                {text: '50', value: 50},
                                                {text: this.$t('todos'), value: -1}
                                            ],
                                            itemsPerPageText: $t('filas_por_pagina')
                                        }"
                                        class="elevation-1"
                                        :no-data-text="$t('no_records_yet')"
                                >
                                    <template v-slot:item.action="{ item }">
                                      <div v-if="item.from !== 'app' && item.from !== 'residence_request'">
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon
                                                        v-if="item.temporalToken === ''"
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        medium
                                                        color="gray"
                                                        class="mr-2"
                                                        @click="fillFields(item), getHouses(), update = true, dialog = true, id_update = item.id"
                                                >
                                                    mdi-account-edit
                                                </v-icon>
                                            </template>
                                            <span>{{$t('change')}}</span>
                                        </v-tooltip>
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon
                                                        v-if="item.temporalToken === ''"
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        medium
                                                        color="red"
                                                        class="mr-2"
                                                        @click="deleteDialog = true, idMainResidentDelete = item.id"
                                                >
                                                    mdi-delete
                                                </v-icon>
                                            </template>
                                            <span>{{$t('delete')}}</span>
                                        </v-tooltip>
                                        <v-tooltip bottom>
                                            <template v-slot:activator="{ on, attrs }">
                                                <v-icon
                                                        v-if="item.temporalToken === ''"
                                                        v-bind="attrs"
                                                        v-on="on"
                                                        medium
                                                        color="primary"
                                                        class="mr-2"
                                                        @click="idMainResidentDelete = item.id, getResidentsByPrincipalResident(item.address, item.fullname)"
                                                >
                                                    mdi-account-supervisor
                                                </v-icon>
                                            </template>
                                            <span>{{$t('show_secondary_residents')}}</span>
                                        </v-tooltip>
                                      </div>
                                    </template>
                                    <template v-slot:item.temporalToken="{ item }">
                                        <div v-if="item.from === 'residence_request'">
                                            <v-btn
                                                    @click="confirm = null, feedback = null, temporalResidenceRequestId = item.id, residenceRequestInfo = item, dialogInfoResidenceRequest = true"
                                                    color="primary">
                                                {{$t('validar')}}
                                            </v-btn>
                                        </div>
                                        <div v-else-if="item.from === 'app'">
                                            <v-btn
                                                    @click="getHouseInfoPreMainResident(item.id), confirm = null, feedback = null, temporalId= item.id, dialogInfoPreMainResidentAndResidents = true"
                                                    color="primary">
                                                {{$t('validar')}}
                                            </v-btn>
                                        </div>
                                        <div v-else>
                                          <div v-if="item.temporalToken !== ''">
                                              <v-btn
                                                      @click="getHouseInfo(item.temporalToken), confirm = null, feedback = null, temporalToken= item.temporalToken, dialogInfoMainResidentAndResidents = true"
                                                      color="primary">
                                                  {{$t('validar')}}
                                              </v-btn>
                                          </div>
                                          <div v-else>
                                              <v-icon
                                                      medium
                                                      color="primary"
                                                      class="mr-2"
                                              >
                                                  mdi-check
                                              </v-icon>
                                          </div>
                                        </div>
                                    </template>
                                    <template v-slot:item.can_send="{ item }">
                                      <div v-if="item.from === 'app' || item.from === 'residence_request'">
                                            <v-btn
                                                    disabled
                                                    block
                                                    color="primary">
                                                {{$t('activar')}}
                                            </v-btn>
                                      </div>
                                      <div v-else>
                                        <div v-if="item.can_send === true && item.temporalToken === ''">
                                            <v-btn
                                                    block
                                                    dark
                                                    @click="dialogEnableDisable = true, disable = true, enable = false, idHouse = item.idHouse"
                                                    color="red">
                                                {{$t('desactivar')}}
                                            </v-btn>
                                        </div>
                                        <div v-else-if="item.can_send === false && item.temporalToken === ''">
                                            <v-btn
                                                    block
                                                    @click="dialogEnableDisable = true, disable = false, enable = true, idHouse = item.idHouse"
                                                    color="primary">
                                                {{$t('activar')}}
                                            </v-btn>
                                        </div>
                                        <div v-else-if="item.temporalToken !== ''">
                                            <v-btn
                                                    disabled
                                                    block
                                                    color="primary">
                                                {{$t('activar')}}
                                            </v-btn>
                                        </div>
                                      </div>
                                    </template>
                                    <template v-slot:item.defaulter="{ item }">
                                      <div v-if="item.from === 'app' || item.from === 'residence_request'">
                                            <v-btn
                                                    disabled
                                                    block
                                                    color="primary">
                                                {{$t('unlock')}}
                                            </v-btn>
                                      </div>
                                      <div v-else>
                                        <div v-if="item.defaulter === true && item.temporalToken === ''">
                                            <v-btn
                                                    block
                                                    @click="dialogDefaulter = true, disable = true, enable = false, idHouse = item.idHouse"
                                                    color="primary">
                                                {{$t('unlock')}}
                                            </v-btn>
                                        </div>
                                        <div v-else-if="item.defaulter === false && item.temporalToken === ''">
                                            <v-btn
                                                    block
                                                    dark
                                                    @click="dialogDefaulter = true, disable = false, enable = true, idHouse = item.idHouse"
                                                    color="red">
                                                {{$t('block_for_non_payment')}}
                                            </v-btn>
                                        </div>
                                        <div v-else-if="item.temporalToken !== ''">
                                            <v-btn
                                                    disabled
                                                    block
                                                    color="primary">
                                                {{$t('unlock')}}
                                            </v-btn>
                                        </div>
                                      </div>
                                    </template>
                                    <template v-slot:no-results>
                                        <v-alert type="warning">
                                            {{$t('ningun_resultado_1')}} "{{ search }}" {{$t('ningun_resultado_2')}}
                                        </v-alert>
                                    </template>
                                </v-data-table>
                            </v-flex>
                        </v-layout>
                    </v-card-text>
                </v-card>
            </v-tab-item>
<!--            <v-tab-item>-->
<!--                <v-card flat>-->
<!--                    <v-card-text>-->
<!--                        <v-layout class="my-4" align-center justify-center fill-height>-->
<!--                            <v-flex >-->
<!--                                <v-card-title>-->
<!--                                    <v-spacer></v-spacer>-->
<!--                                    <v-text-field-->
<!--                                            v-model="searchPreMainResidents"-->
<!--                                            append-icon="mdi-account-search"-->
<!--                                            :label="$t('Buscar')"-->
<!--                                            single-line-->
<!--                                            hide-details-->
<!--                                    ></v-text-field>-->
<!--                                </v-card-title>-->
<!--                                <v-data-table-->
<!--                                        :headers="headers2"-->
<!--                                        :loading="loadingDataMainResidents"-->
<!--                                        :items="preMainResidents"-->
<!--                                        :search="searchPreMainResidents"-->
<!--                                        :footer-props="{-->
<!--                                            itemsPerPageOptions: [-->
<!--                                                {text: '5', value: 5},-->
<!--                                                {text: '10', value: 10},-->
<!--                                                {text: '25', value: 25},-->
<!--                                                {text: this.$t('todos'), value: -1}-->
<!--                                            ],-->
<!--                                            itemsPerPageText: $t('filas_por_pagina')-->
<!--                                        }"-->
<!--                                        class="elevation-1"-->
<!--                                        :no-data-text="$t('no_records_yet')"-->
<!--                                >-->
<!--                                    <template v-slot:item.street="{ item }">-->
<!--                                        {{item.street}} {{item.numberHouse}}-->
<!--                                    </template>-->
<!--                                    <template v-slot:item.temporalToken="{ item }">-->
<!--                                        <div v-if="item.temporalToken !== ''">-->
<!--                                            <v-btn-->
<!--                                                    @click="getHouseInfoPreMainResident(item.id), confirm = null, feedback = null, temporalId= item.id, dialogInfoPreMainResidentAndResidents = true"-->
<!--                                                    color="primary">-->
<!--                                                {{$t('validar')}}-->
<!--                                            </v-btn>-->
<!--                                        </div>-->
<!--                                        <div v-else>-->
<!--                                            <v-icon-->
<!--                                                    medium-->
<!--                                                    color="primary"-->
<!--                                                    class="mr-2"-->
<!--                                            >-->
<!--                                                mdi-check-->
<!--                                            </v-icon>-->
<!--                                        </div>-->
<!--                                    </template>-->
<!--                                    <template v-slot:no-results>-->
<!--                                        <v-alert type="warning">-->
<!--                                            {{$t('ningun_resultado_1')}} "{{ searchPreMainResidents }}" {{$t('ningun_resultado_2')}}-->
<!--                                        </v-alert>-->
<!--                                    </template>-->
<!--                                </v-data-table>-->
<!--                            </v-flex>-->
<!--                        </v-layout>-->
<!--                    </v-card-text>-->
<!--                </v-card>-->
<!--            </v-tab-item>-->
        </v-tabs>
    </v-container>
</template>

<script>
import axios from 'axios'
import store from '@/store'
import VuejsClipper from 'vuejs-clipper'
import { ValidationProvider, ValidationObserver, extend } from 'vee-validate'
import { mapState, mapGetters, mapActions } from 'vuex'
import Vue from 'vue'
import { required } from 'vee-validate/dist/rules'

extend('password', {
  params: ['target'],
  validate (value, { target }) {
    return value === target
  },
  message: 'Password confirmation does not match'
})

extend('required', {
  ...required,
  message: 'This field is required'
})

Vue.component('ValidationProvider', ValidationProvider)
Vue.component('ValidationObserver', ValidationObserver)
Vue.use(VuejsClipper, {
  components: {
    clipperBasic: 'clipper-basic',
    clipperFixed: 'clipper-fixed',
    clipperUpload: 'clipper-upload'
  }
})

// const dictionary = {
//   en: {
//     messages: {
//       confirmed: () => 'The passwords didn\'t match',
//       required: () => 'This field is required'
//     }
//   },
//   es: {
//     messages: {
//       confirmed: () => 'Las contraseñas no coinciden',
//       required: () => 'Este campo es requerido'
//     }
//   }
// }

// Validator.localize(dictionary)
// const validator = new Validator({ confirmation: 'confirmed' })
// Falta investigar como cambiar el idioma de los mensajes
// con vue-validate
// validator.localize(this.$store.state.language);
// validator.localize('es')

export default {
  name: 'main_residents',
  created: function () {
    this.getProfileData()
    this.getMainResidents()
    this.fetchResidencePendingRequests()
  },
  data: () => ({
    show: false,
    alerta: false,
    dialog: false,
    dialogDataResident: false,
    update: false,
    id_update: 0,
    id_house: '',
    first_name: '',
    last_name: '',
    payroll_number: '',
    celular: '',
    email: '',
    email_aux: '',
    celular_aux: '',
    password: '',
    errores: [],
    errores_seg: [],
    houses: [],
    allResidents: [],
    address_aux: '',
    fullname_axu: '',
    mainResidents: [],
    preMainResidents: [],
    change_password: '',
    loadingDataMainResidents: false,
    loadingDataAllResidents: false,
    loading: false,
    confirmation: '',
    search: '',
    searchAllResidents: '',
    searchPreMainResidents: '',
    // Imágenes
    dialogImageFront: false,
    dialogImageBack: false,
    dialogImageProfile: false,
    imageFrontURL: '',
    imageBackURL: '',
    imageProfileURL: '',
    resultFrontURL: '',
    resultBackURL: '',
    resultProfileURL: '',
    resultAuxFrontURL: '',
    resultAuxBackURL: '',
    resultAuxProfileURL: '',
    // Delete MainResident
    deleteDialog: false,
    idMainResidentDelete: 0,
    // Move Up
    dialogMoveUp: false,
    emailGuest: '',
    isLoading: false,
    search2: null,
    entries: [],
    band_cellphone: false,
    dialogCellNumberWrong: false,
    dialogNoSecondaryResidents: false,
    // Info Main Resident and Residents
    step: 1,
    residentes: [],
    headersResident: [],
    dialog_residente: false,
    editedIndex: -1,
    editedItem: {
      idUser: {
        first_name: '',
        last_name: '',
        email: '',
        cellNumber: '',
        puede_enviar: false,
        avatar: ''
      }
    },
    houseInfo: [],
    houseInfoPreMainResident: [],
    confirm: null,
    dialogConfirm: false,
    dialogInfoMainResidentAndResidents: false,
    dialogInfoPreMainResidentAndResidents: false,
    dialogInfoResidenceRequest: false,
    temporalToken: '',
    temporalId: '',
    temporalResidenceRequestId: '',
    residenceRequestInfo: null,
    profileData: {},
    loadingSkeleton: false,
    dialogEnableDisable: false,
    dialogDefaulter: false,
    disable: false,
    enable: false,
    idHouse: 0,
    dialogUpdateQRCodes: false,
    dialogAllResidents: false,
    QRCodes: null,
    loadingQRCodes: false,
    degrees: 0,
    ratio: '1',
    rented_house: '',
    bandPreMainResident: false,
    feedback: null,
    dialogTimeUnlock: false,
    loading_send_email: false,
    loadingSync: false,
    notify_on_no_code_access: false,
    notify_on_worker_access: false,
    is_director: false
  }),
  beforeUpdate () {
    this.headersResident = [
      {
        text: this.$t('acciones'),
        align: 'center',
        value: 'action',
        sortable: false
      },
      {
        text: this.$t('Nombre'),
        align: 'center',
        sortable: true,
        value: 'idUser.first_name'
      },
      {
        text: this.$t('Apellido'),
        align: 'center',
        sortable: true,
        value: 'idUser.last_name'
      },
      {
        text: this.$t('celular'),
        align: 'center',
        sortable: true,
        value: 'idUser.cellNumber'
      },
      {
        text: 'E-Mail',
        align: 'center',
        sortable: true,
        value: 'idUser.email'
      }
    ]
  },
  computed: {
    headersAllResidents () {
      return [
        {
          text: this.$t('acciones'),
          align: 'center',
          value: 'action',
          sortable: false
        },
        {
          text: this.$t('residente'),
          align: 'center',
          sortable: true,
          value: 'principal'
        },
        {
          text: this.$t('payroll_number'),
          align: 'left',
          sortable: true,
          value: 'payroll_number'
        },
        {
          text: this.$t('nombre'),
          align: 'left',
          sortable: false,
          value: 'fullname'
        },
        {
          text: this.$t('direccion'),
          align: 'left',
          sortable: true,
          value: 'address'
        },
        {
          text: this.$t('celular'),
          align: 'left',
          sortable: false,
          value: 'idUser.cellNumber'
        },
        {
          text: 'E-Mail',
          align: 'left',
          sortable: false,
          value: 'idUser.email'
        }
      ]
    },
    headersAllResidents2 () {
      return [
        {
          text: this.$t('acciones'),
          align: 'center',
          value: 'action',
          sortable: false
        },
        {
          text: this.$t('residente'),
          align: 'center',
          sortable: true,
          value: 'principal'
        },
        {
          text: this.$t('nombre'),
          align: 'left',
          sortable: false,
          value: 'fullname'
        },
        {
          text: this.$t('direccion'),
          align: 'left',
          sortable: true,
          value: 'address'
        },
        {
          text: this.$t('celular'),
          align: 'left',
          sortable: false,
          value: 'idUser.cellNumber'
        },
        {
          text: 'E-Mail',
          align: 'left',
          sortable: false,
          value: 'idUser.email'
        }
      ]
    },
    headers () {
      return [
        {
          text: this.$t('acciones'),
          align: 'center',
          value: 'action',
          sortable: false
        },
        {
          text: this.$t('validado'),
          align: 'center',
          sortable: true,
          value: 'temporalToken'
        },
        {
          text: this.$t('activar_desactivar'),
          align: 'center',
          sortable: true,
          value: 'can_send'
        },
        {
          text: this.$t('defaulter'),
          align: 'center',
          sortable: true,
          value: 'defaulter'
        },
        {
          text: this.$t('payroll_number'),
          align: 'left',
          sortable: true,
          value: 'payroll_number'
        },
        {
          text: this.$t('nombre'),
          align: 'left',
          sortable: true,
          value: 'fullname'
        },
        {
          text: this.$t('direccion'),
          align: 'left',
          sortable: true,
          value: 'address'
        },
        {
          text: this.$t('celular'),
          align: 'left',
          sortable: true,
          value: 'idUser.cellNumber'
        },
        {
          text: 'E-Mail',
          align: 'left',
          sortable: true,
          value: 'idUser.email'
        }
      ]
    },
    headers2 () {
      return [
        {
          text: this.$t('acciones'),
          align: 'center',
          value: 'action',
          sortable: false
        },
        {
          text: this.$t('validado'),
          align: 'center',
          sortable: true,
          value: 'temporalToken'
        },
        {
          text: this.$t('activar_desactivar'),
          align: 'center',
          sortable: true,
          value: 'can_send'
        },
        {
          text: this.$t('defaulter'),
          align: 'center',
          sortable: true,
          value: 'defaulter'
        },
        {
          text: this.$t('nombre'),
          align: 'left',
          sortable: true,
          value: 'fullname'
        },
        {
          text: this.$t('direccion'),
          align: 'left',
          sortable: true,
          value: 'address'
        },
        {
          text: this.$t('celular'),
          align: 'left',
          sortable: true,
          value: 'idUser.cellNumber'
        },
        {
          text: 'E-Mail',
          align: 'left',
          sortable: true,
          value: 'idUser.email'
        }
      ]
    },
    currentTitle () {
      switch (this.step) {
        case 1: return this.$t('datos_vivienda')
        case 2: return this.$t('datos_residente_principal')
        default: return this.$t('datos_residentes')
      }
    },
    ...mapState(['language']),
    ...mapGetters(['getProfile']),
    ...mapGetters({ getPendingResidenceRequests: 'getPendingRequests' }),
    residenceRequestRows () {
      return (this.getPendingResidenceRequests || []).map(req => {
        const idUser = req.idUser || {}
        let house = null
        if (req.idHouse && typeof req.idHouse === 'object') {
          house = req.idHouse
        } else {
          house = this.houses.find(h => h.id === req.idHouse) || null
        }
        return {
          id: req.id,
          temporalToken: '',
          from: 'residence_request',
          principal: true,
          can_send: false,
          defaulter: false,
          payroll_number: '',
          fullname: `${idUser.first_name || ''} ${idUser.last_name || ''}`.trim(),
          address: house ? `${house.street} #${house.number}` : this.$t('no_disponible'),
          idHouse: house,
          idUser: idUser
        }
      })
    },
    tableMainResidents () {
      return [...this.residenceRequestRows, ...this.mainResidents]
    },
    fields () {
      if (!this.emailGuest) return []

      return Object.keys(this.emailGuest).map(key => {
        return {
          key,
          value: this.emailGuest[key] || 'n/a'
        }
      })
    },
    items () {
      return this.entries.map(entry => {
        const email = entry.first_name.length > this.descriptionLimit
          ? entry.first_name.slice(0, this.descriptionLimit) + '...'
          : entry.first_name

        return Object.assign({}, entry, { email })
      })
    }
  },
  watch: {
    isUpdating (val) {
      if (val) {
        setTimeout(() => (this.isUpdating = false), 3000)
      }
    },
    search2 (val) {
      if (val.length > 2) {
        this.isLoading = true
        // Lazily load input items
        const config = {
          method: 'get',
          url: 'https://residencial-services.intrare.app/guests/filter?search=' + val,
          headers: {
            'Content-Type': 'application/json',
            'authorization': 'Token ' + store.getters.getToken
          }
        }
        axios(config)
          .then(response => {
            console.log(response.data)
            if (this.entries.length > 0) {
              for (var i = 0; i < response.data.length; i++) {
                this.entries.push(response.data[i])
              }
            } else {
              this.entries = response.data
            }
          })
          .catch(error => {
            console.log(error)
          })
          .finally(() => (this.isLoading = false))
      }
    }
  },
  methods: {
    ...mapActions({
      fetchResidencePendingRequests: 'fetchPendingRequests',
      validateResidenceRequest: 'validateAddHouse'
    }),
    sendEmail (uuid) {
      this.loading_send_email = true
      let records = []
      records.push({
        'id': uuid
      })
      console.log(records)
      const config = {
        method: 'post',
        url: 'https://residencial-services.intrare.app/residents/send_email/list',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        },
        data: records
      }
      axios(config).then(ok => {
        this.loading_send_email = false
        this.$store.commit('snackbar_activate_true')
        this.$store.commit('snackbar_change_color', 'success')
        this.$store.commit('snackbar_change_message', this.$t('mensaje_email_sent'))
      }).catch(error => {
        this.loading_send_email = false
        if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
          this.errores = error.response.data
        }
      })
    },
    getProfileData () {
      const config = {
        method: 'get',
        url: 'https://residencial-services.intrare.app/users/me/',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          this.profileData = response.data
          this.getHouses()
        })
        .catch(error => {
          console.log(error)
        })
    },
    getHouses: function () {
      const config = {
        method: 'get',
        url: 'https://residencial-services.intrare.app/house/' + this.profileData.idHousingUnit + '/housingunit/',
        headers: {
          'Content-Type': 'application/json'
        }
      }
      axios(config)
        .then(response => {
          this.houses = response.data
        })
        .catch(error => {
          console.log(error)
        })
    },
    getMainResidents: function () {
      this.loadingDataMainResidents = true
      const config = {
        method: 'get',
        url: 'https://residencial-services.intrare.app/principal_resident/v3/',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          this.mainResidents = response.data.allResidents
          this.preMainResidents = []
          this.loadingDataMainResidents = false
        })
        .catch(error => {
          this.loadingDataMainResidents = false
          console.log(error)
        })
    },
    getAllResidents: function () {
      this.address_aux = ''
      this.fullname_axu = ''
      this.searchAllResidents = ''
      this.loadingDataAllResidents = true
      const config = {
        method: 'get',
        url: 'https://residencial-services.intrare.app/residents/all',
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          this.allResidents = response.data.residents
          this.loadingDataAllResidents = false
          this.dialogAllResidents = true
        })
        .catch(error => {
          this.loadingDataAllResidents = false
          console.log(error)
        })
    },
    getResidentsByPrincipalResident (address, fullname) {
      this.address_aux = address
      this.fullname_axu = fullname
      this.searchAllResidents = ''
      this.loadingDataAllResidents = true
      const config = {
        method: 'get',
        url: 'https://residencial-services.intrare.app/resident/all/' + this.idMainResidentDelete,
        headers: {
          'Content-Type': 'application/json',
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          if (response.status === 204) {
            this.allResidents = []
            //  Mostrar mensaje: No tiene registrados residentes secundarios
            this.dialogNoSecondaryResidents = true
          } else {
            this.allResidents = response.data
            this.dialogAllResidents = true
          }
          this.loadingDataAllResidents = false
        })
        .catch(error => {
          this.loadingDataAllResidents = false
          console.log(error)
        })
    },
    createMainResident: function () {
      if (this.id_house === '') {
        this.id_house = null
      }
      this.errores = []
      this.errores_seg = []
      if (this.band_cellphone === true) {
        this.loading = true
        var bodyFormData = new FormData()
        var fileImageFront = null
        var fileImageBack = null
        var fileImageProfile = null

        bodyFormData.set('idUser.first_name', this.first_name)
        bodyFormData.set('idUser.last_name', this.last_name)
        bodyFormData.set('payroll_number', this.payroll_number)
        bodyFormData.set('idUser.cellNumber', this.celular)
        bodyFormData.set('idUser.email', this.email.toLowerCase())
        bodyFormData.set('idUser.password', this.password)
        bodyFormData.set('idHouse', this.id_house)
        if (this.resultFrontURL !== '' && this.resultFrontURL.length > 6) {
          fileImageFront = this.dataURLtoFile(this.resultFrontURL, 'ine_front.jpeg')
        }
        bodyFormData.append('idUser.idFront', fileImageFront)
        if (this.resultBackURL !== '' && this.resultBackURL.length > 6) {
          fileImageBack = this.dataURLtoFile(this.resultBackURL, 'ine_back.jpeg')
        }
        bodyFormData.append('idUser.idBack', fileImageBack)
        if (this.resultProfileURL !== '' && this.resultProfileURL.length > 6) {
          fileImageProfile = this.dataURLtoFile(this.resultProfileURL, 'avatar.jpeg')
        }
        bodyFormData.append('idUser.avatar', fileImageProfile)
        const config = {
          method: 'post',
          url: 'https://residencial-services.intrare.app/principal_resident/',
          headers: {
            'Content-Type': 'application/json',
            'Accept-Language': this.language,
            'authorization': 'Token ' + store.getters.getToken
          },
          data: bodyFormData
        }
        axios(config)
          .then(ok => {
            this.loading = false
            this.getMainResidents()
            this.$store.commit('snackbar_activate_true')
            this.$store.commit('snackbar_change_message', this.$t('mensaje_mainresident_alta'))
            this.dialog = false
            setTimeout(this.clear, 3000)
          })
          .catch(error => {
            this.loading = false
            if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
              if (error.response.data) {
                this.errores = error.response.data
              }
              if (error.response.data.idUser) {
                this.errores_seg = error.response.data.idUser
              }
            }
          })
      } else {
        this.dialogCellNumberWrong = true
      }
    },
    updateMainResident: function (id) {
      if (this.band_cellphone === true) {
        this.errores = []
        this.errores_seg = []
        this.loading = true
        var bodyFormData = new FormData()
        var fileImageFront = null
        var fileImageBack = null
        var fileImageProfile = null
        // Evitar Campo Fraccionamiento vacío
        if (this.id_house === undefined) {
          this.id_house = ''
        }
        if (this.email_aux !== this.email) {
          // idUser['email'] = this.email.toLowerCase()
          bodyFormData.set('idUser.email', this.email.toLowerCase())
        }
        if (this.celular_aux !== this.celular) {
          bodyFormData.set('idUser.cellNumber', this.celular)
          // idUser['cellNumber'] = this.celular
        }
        if (this.change_password === true) {
          bodyFormData.set('idUser.password', this.password)
          // idUser['password'] = this.password
        }
        if (this.resultFrontURL !== this.resultAuxFrontURL) {
          const newID = this.$uuid.v4()
          if (this.resultFrontURL !== '' && this.resultFrontURL.length > 6) {
            fileImageFront = this.dataURLtoFile(this.resultFrontURL, 'ine_front' + newID + '.jpeg')
          }
          bodyFormData.append('idUser.idFront', fileImageFront)
        }
        if (this.resultBackURL !== this.resultAuxBackURL) {
          const newID = this.$uuid.v4()
          if (this.resultBackURL !== '' && this.resultBackURL.length > 6) {
            fileImageBack = this.dataURLtoFile(this.resultBackURL, 'ine_back' + newID + '.jpeg')
          }
          bodyFormData.append('idUser.idBack', fileImageBack)
        }
        if (this.resultProfileURL !== this.resultAuxProfileURL) {
          const newID = this.$uuid.v4()
          if (this.resultProfileURL !== '' && this.resultProfileURL.length > 6) {
            fileImageProfile = this.dataURLtoFile(this.resultProfileURL, 'avatar' + newID + '.jpeg')
          }
          bodyFormData.append('idUser.avatar', fileImageProfile)
        }
        bodyFormData.set('idUser.first_name', this.first_name)
        bodyFormData.set('idUser.last_name', this.last_name)
        bodyFormData.set('payroll_number', this.payroll_number)
        bodyFormData.set('idHouse', this.id_house)
        bodyFormData.set('notify_on_no_code_access', false)
        bodyFormData.set('notify_on_worker_access', false)
        // datos = {
        //   idUser: idUser,
        //   idHousingUnit: this.id_house
        // }
        const config = {
          method: 'patch',
          url: 'https://residencial-services.intrare.app/principal_resident/' + id,
          headers: {
            'Content-Type': 'application/json',
            'Accept-Language': this.language,
            'authorization': 'Token ' + store.getters.getToken
          },
          data: bodyFormData
        }
        axios(config)
          .then(() => {
            this.updateMainResidentDirector(id)
          })
          .catch(error => {
            this.loading = false
            console.log(error.response.data)
            if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
              if (error.response.data) {
                this.errores = error.response.data
              }
              if (error.response.data.idUser) {
                this.errores_seg = error.response.data.idUser
              }
            }
          })
      } else {
        this.dialogCellNumberWrong = true
      }
    },
    updateMainResidentDirector (id) {
      const config = {
        method: 'patch',
        url: 'https://residencial-services.intrare.app/resident/' + id + '/director/',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'Authorization': 'Token ' + store.getters.getToken
        },
        data: {
          is_director: this.is_director
        }
      }
      axios(config)
        .then(() => {
          this.loading = false
          this.getMainResidents()
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', this.$t('mensaje_mainresident_modificado'))
          this.dialog = false
          setTimeout(this.clear, 3000)
        })
        .catch(error => {
          this.loading = false
          console.log(error)
          if (error.response && error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            this.errores = error.response.data
          }
        })
    },
    updateResident: function (id) {
      this.errores = []
      this.errores_seg = []
      this.loading = true
      var bodyFormData = new FormData()
      // Evitar Campo Fraccionamiento vacío
      if (this.id_house === undefined) {
        this.id_house = ''
      }
      bodyFormData.set('idUser.first_name', this.first_name)
      bodyFormData.set('payroll_number', this.payroll_number)
      bodyFormData.set('idHouse', this.id_house)
      bodyFormData.set('notify_on_no_code_access', this.notify_on_no_code_access)
      bodyFormData.set('notify_on_worker_access', this.notify_on_worker_access)
      const config = {
        method: 'patch',
        url: 'https://residencial-services.intrare.app/resident/' + id,
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        },
        data: bodyFormData
      }
      axios(config)
        .then(ok => {
          this.loading = false
          if (this.fullname_axu === '') {
            this.getAllResidents()
          } else {
            this.getResidentsByPrincipalResident(this.address_aux, this.fullname_axu)
          }
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', this.$t('self_validate_exito'))
          this.dialogDataResident = false
          setTimeout(this.clear, 3000)
        })
        .catch(error => {
          this.loading = false
          console.log(error.response.data)
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            if (error.response.data) {
              this.errores = error.response.data
            }
            if (error.response.data.idUser) {
              this.errores_seg = error.response.data.idUser
            }
          }
        })
    },
    deleteMainResident () {
      let URL = ''
      if (this.bandPreMainResident === false) {
        URL = 'https://residencial-services.intrare.app/principal_resident/' + this.idMainResidentDelete
      } else {
        URL = 'https://residencial-services.intrare.app/prePrincipalResident/' + this.idMainResidentDelete + '/validate/'
      }
      const config = {
        method: 'delete',
        url: URL,
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config).then(ok => {
        console.log('Main Resident con ID = ', this.idMainResidentDelete + ' eliminado Correctamente.')
        this.$store.commit('snackbar_activate_true')
        this.$store.commit('snackbar_change_color', 'warning')
        this.$store.commit('snackbar_change_message', this.$t('mensaje_mainresident_eliminado'))
        this.getMainResidents()
        setTimeout(this.clear, 3000)
        this.deleteDialog = false
      })
        .catch(error => {
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            this.errores = error.response.data
          }
        })
      this.bandPreMainResident = false
    },
    moveUpUserToMainResident () {
      this.errores = []
      this.loading = true
      const config = {
        method: 'PATCH',
        url: 'https://residencial-services.intrare.app/principal_resident/make_from_guest/',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        },
        data: {
          idUser: this.emailGuest,
          idHouse: this.id_house
        }
      }
      axios(config)
        .then(ok => {
          this.loading = false
          this.getMainResidents()
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', this.$t('msg_cambio_permisos'))
          this.dialogMoveUp = false
          setTimeout(this.clear, 3000)
        })
        .catch(error => {
          this.loading = false
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            this.errores = error.response.data
          }
        })
    },
    clear: function () {
      this.temporalToken = ''
      this.temporalId = ''
      this.temporalResidenceRequestId = ''
      this.residenceRequestInfo = null
      this.confirm = null
      this.alerta = false
      this.errores = []
      this.errores_seg = []
      this.idHouse = 0
      // this.$validator.reset()
      this.$store.commit('snackbar_change_color', 'success')
      this.$store.commit('snackbar_activate_false')
    },
    fillFields (item) {
      this.id_house = item.idHouse
      this.first_name = item.idUser.first_name
      this.last_name = item.idUser.last_name
      if (item.payroll_number === null) {
        this.payroll_number = ''
      } else {
        this.payroll_number = item.payroll_number
      }
      this.celular = item.idUser.cellNumber
      this.email = item.idUser.email
      this.email_aux = item.idUser.email
      this.celular_aux = item.idUser.cellNumber
      this.password = ''
      this.confirmation = ''
      this.change_password = false
      this.rented_house = item.rented_house
      this.is_director = item.is_director || false
      this.resultFrontURL = item.idUser.idFront
      this.resultBackURL = item.idUser.idBack
      this.resultProfileURL = item.idUser.avatar
      this.resultAuxFrontURL = item.idUser.idFront
      this.resultAuxBackURL = item.idUser.idBack
      this.resultAuxProfileURL = item.idUser.avatar
      this.band_cellphone = true
      this.notify_on_no_code_access = item.notify_on_no_code_access || false
      this.notify_on_worker_access = item.notify_on_worker_access || false
    },
    example2: item => (item.street === null ? 'n/a' : item.street) + ' ' + (item.number === null ? 'n/a' : item.number) + ' (' + (item.phone === null ? 'n/a' : item.phone) + ')',
    customFilter (item, queryText) {
      var text = ''
      if (item.number === null || item.number === '') {
        text = 'n/a'
      } else {
        text = item.number.toLowerCase()
      }
      const searchText = queryText.toLowerCase()
      return text.indexOf(searchText) > -1
    },
    cleanFields () {
      this.id_house = ''
      this.first_name = ''
      this.last_name = ''
      this.payroll_number = ''
      this.celular = ''
      this.email = ''
      this.email_aux = ''
      this.celular_aux = ''
      this.password = ''
      this.confirmation = ''
      this.change_password = true
      this.rented_house = false
      this.is_director = false
      this.resultFrontURL = ''
      this.resultBackURL = ''
      this.resultProfileURL = ''
      this.notify_on_no_code_access = false
      this.notify_on_worker_access = false
    },
    example: item => item.first_name + ' ' + item.last_name,
    getCutingFront () {
      console.log('Datos de la imagen = ', this.imageFrontURL.size)
      const canvas = this.$refs.clipperImageFront.clip() // call component's clip method
      this.resultFrontURL = canvas.toDataURL('image/jpeg', 0.2) // canvas->image
      console.log(this.resultFrontURL)
      this.dialogImageFront = false
      this.dialog = true
    },
    getCutingBack () {
      const canvas = this.$refs.clipperImageBack.clip() // call component's clip method
      this.resultBackURL = canvas.toDataURL('image/jpeg', 0.2) // canvas->image
      console.log(this.resultBackURL)
      this.dialogImageBack = false
      this.dialog = true
    },
    getCutingProfile () {
      const canvas = this.$refs.clipperImageProfile.clip() // call component's clip method
      this.resultProfileURL = canvas.toDataURL('image/jpeg', 0.2) // canvas->image
      console.log(this.resultProfileURL)
      this.dialogImageProfile = false
      this.dialog = true
    },
    dataURLtoFile (dataurl, filename) {
      var arr = dataurl.split(',')
      var mime = arr[0].match(/:(.*?);/)[1]
      var bstr = atob(arr[1])
      var n = bstr.length
      var u8arr = new Uint8Array(n)
      while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
      }
      return new File([u8arr], filename, { type: mime })
    },
    onInput ({ number, isValid, country }) {
      console.log(number.e164)
      console.log(isValid)
      console.log(country)
      this.celular = number.e164
      this.band_cellphone = isValid
    },
    editResident (item) {
      console.log(item)
      this.editedIndex = this.houseInfo[0].residents.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog_residente = true
    },
    getHouseInfo (token) {
      this.loadingSkeleton = true
      const config = {
        method: 'get',
        url: 'https://residencial-services.intrare.app/house/get/principal_resident/data/' + token + '/',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          this.loadingSkeleton = false
          console.log('Información de la Casa: ')
          this.houseInfo = response.data
          console.log(this.houseInfo[0].residents)
        })
        .catch(error => {
          this.loadingSkeleton = false
          console.log(error)
        })
    },
    getHouseInfoPreMainResident (id) {
      this.loadingSkeleton = true
      const config = {
        method: 'get',
        url: 'https://residencial-services.intrare.app/prePrincipalResident/data/' + id + '/',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          this.loadingSkeleton = false
          console.log('Información de la Casa: ')
          this.houseInfoPreMainResident = response.data
          console.log(this.houseInfoPreMainResident)
        })
        .catch(error => {
          this.loadingSkeleton = false
          console.log(error)
        })
    },
    getStatusUpdateQRCode () {
      const config = {
        method: 'get',
        url: 'https://residencial-services.intrare.app/housing_unit/info/',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        }
      }
      axios(config)
        .then(response => {
          this.QRCodes = response.data.update_codes
        })
        .catch(error => {
          console.log(error)
        })
    },
    updateQRCodes () {
      this.loadingQRCodes = true
      const config = {
        method: 'patch',
        url: 'https://residencial-services.intrare.app/housing_unit/update/wallpaper/',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        },
        data: {
          update_codes: this.QRCodes
        }
      }
      axios(config)
        .then(ok => {
          // console.log(ok)
          this.loadingQRCodes = false
          this.dialogUpdateQRCodes = false
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_message', this.$t('cambios_aplicados'))
          setTimeout(this.clear, 3000)
        })
        .catch(error => {
          this.loadingQRCodes = false
          if (error.response.status === 400 && typeof error.response.data === 'object' && error.response.data) {
            this.errores = error.response.data
          }
        })
    },
    syncResidentsToMiddleware () {
      this.loadingSync = true
      if (!this.profileData.idHousingUnit) {
        this.loadingSync = false
        this.$store.commit('snackbar_activate_true')
        this.$store.commit('snackbar_change_color', 'error')
        this.$store.commit('snackbar_change_message', 'No housing unit ID found')
        return
      }

      const config = {
        method: 'post',
        url: 'https://residencial-services.intrare.app/residents/bulk/sync/' + this.profileData.idHousingUnit + '/',
        headers: {
          'Content-Type': 'application/json',
          'Accept-Language': this.language,
          'authorization': 'Token ' + store.getters.getToken
        },
        data: {
          action: 'sync'
        }
      }
      axios(config)
        .then(response => {
          this.loadingSync = false
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_color', 'success')
          this.$store.commit('snackbar_change_message', response.data.message || 'Sincronización enviada correctamente')
        })
        .catch(error => {
          this.loadingSync = false
          console.error(error)
          this.$store.commit('snackbar_activate_true')
          this.$store.commit('snackbar_change_color', 'error')

          let errorMessage = this.$t('error_generico') || 'Error en la sincronización'
          if (error.response && error.response.data && error.response.data.error) {
            errorMessage = error.response.data.error
          } else if (error.response && error.response.data && error.response.data.message) {
            errorMessage = error.response.data.message
          }

          this.$store.commit('snackbar_change_message', errorMessage)
        })
    },
    blockReactivateResidentsDefaulter () {
      if (this.enable === false) {
        console.log('Activa Todos los Usuarios')
        const config = {
          method: 'patch',
          url: 'https://residencial-services.intrare.app/enable/residents/' + this.idHouse + '/defaulter',
          headers: {
            'Content-Type': 'application/json',
            'authorization': 'Token ' + store.getters.getToken
            // 'Accept-Language': this.language
          }
        }
        axios(config)
          .then(ok => {
            console.log(ok)
            this.getMainResidents()
            this.$store.commit('snackbar_activate_true')
            this.$store.commit('snackbar_change_message', this.$t('mensaje_users_unblocked'))
            this.dialogDefaulter = false
            setTimeout(this.clear, 3000)
          })
          .catch(error => {
            console.log(error)
            if (error.request.status === 403) {
              this.dialogTimeUnlock = true
            }
          })
      } else {
        if (this.disable === false) {
          console.log('Desactiva Todos los Usuarios')
          const config = {
            method: 'patch',
            url: 'https://residencial-services.intrare.app/disable/resident/' + this.idHouse + '/defaulter',
            headers: {
              'Content-Type': 'application/json',
              'authorization': 'Token ' + store.getters.getToken
            }
          }
          axios(config).then(ok => {
            console.log(ok)
            this.getMainResidents()
            this.$store.commit('snackbar_activate_true')
            this.$store.commit('snackbar_change_color', 'warning')
            this.$store.commit('snackbar_change_message', this.$t('mensaje_users_blocked'))
            this.dialogDefaulter = false
            setTimeout(this.clear, 3000)
          })
            .catch(error => {
              console.log(error)
            })
        }
      }
    },
    enableDisableMainResident () {
      if (this.enable === true) {
        console.log('Activa Todos los Usuarios')
        const config = {
          method: 'patch',
          url: 'https://residencial-services.intrare.app/enable/' + this.idHouse + '/residents/',
          headers: {
            'Content-Type': 'application/json',
            'authorization': 'Token ' + store.getters.getToken
            // 'Accept-Language': this.language
          }
        }
        axios(config)
          .then(ok => {
            console.log(ok)
            this.getMainResidents()
            this.$store.commit('snackbar_activate_true')
            this.$store.commit('snackbar_change_message', this.$t('mensaje_users_activados'))
            this.dialogEnableDisable = false
            setTimeout(this.clear, 3000)
          })
          .catch(error => {
            console.log(error)
          })
      } else {
        if (this.disable === true) {
          console.log('Desactiva Todos los Usuarios')
          const config = {
            method: 'patch',
            url: 'https://residencial-services.intrare.app/disable/resident/' + this.idHouse + '/cantsend/',
            headers: {
              'Content-Type': 'application/json',
              'authorization': 'Token ' + store.getters.getToken
            }
          }
          axios(config).then(ok => {
            console.log(ok)
            this.getMainResidents()
            this.$store.commit('snackbar_activate_true')
            this.$store.commit('snackbar_change_color', 'warning')
            this.$store.commit('snackbar_change_message', this.$t('mensaje_users_desactivados'))
            this.dialogEnableDisable = false
            setTimeout(this.clear, 3000)
          })
            .catch(error => {
              console.log(error)
            })
        }
      }
    },
    activateDeleteUsers () {
      if (this.confirm === null) {
        this.dialogConfirm = true
      }
      if (this.confirm === 'true') {
        console.log('Activar Todos los Usuarios')
        this.loading = true
        const config = {
          method: 'patch',
          url: 'https://residencial-services.intrare.app/house/validate/residents/' + this.temporalToken + '/',
          headers: {
            'Content-Type': 'application/json',
            'authorization': 'Token ' + store.getters.getToken
            // 'Accept-Language': this.language
          }
        }
        axios(config)
          .then(ok => {
            console.log(ok)
            this.loading = false
            this.feedback = null
            this.getMainResidents()
            this.$store.commit('snackbar_activate_true')
            this.$store.commit('snackbar_change_message', this.$t('mensaje_users_alta'))
            this.dialogInfoMainResidentAndResidents = false
            setTimeout(this.clear, 3000)
          })
          .catch(error => {
            this.loading = false
            console.log(error)
          })
          .finally(() => (this.loading = false))
      } else {
        if (this.confirm === 'false') {
          console.log('Eliminar Todos los Usuarios')
          this.loading = true
          const config = {
            method: 'delete',
            url: 'https://residencial-services.intrare.app/house/validate/residents/' + this.temporalToken + '/',
            headers: {
              'Content-Type': 'application/json',
              'authorization': 'Token ' + store.getters.getToken
            },
            data: {
              'feedback': this.feedback
            }
          }
          axios(config).then(ok => {
            console.log(ok)
            this.loading = false
            this.feedback = null
            this.getMainResidents()
            this.$store.commit('snackbar_activate_true')
            this.$store.commit('snackbar_change_color', 'warning')
            this.$store.commit('snackbar_change_message', this.$t('mensaje_users_baja'))
            this.dialogInfoMainResidentAndResidents = false
            setTimeout(this.clear, 3000)
          })
            .catch(error => {
              console.log(error)
              this.loading = false
            })
        }
      }
    },
    activateDeleteUsersPreMainResident () {
      if (this.confirm === null) {
        this.dialogConfirm = true
      }
      if (this.confirm === 'true') {
        console.log('Activar Todos los Usuarios')
        this.loading = true
        const config = {
          method: 'patch',
          url: 'https://residencial-services.intrare.app/prePrincipalResident/' + this.temporalId + '/validate/',
          headers: {
            'Content-Type': 'application/json',
            'authorization': 'Token ' + store.getters.getToken
            // 'Accept-Language': this.language
          }
        }
        axios(config)
          .then(ok => {
            console.log(ok)
            this.loading = false
            this.feedback = null
            this.getMainResidents()
            this.$store.commit('snackbar_activate_true')
            this.$store.commit('snackbar_change_message', this.$t('mensaje_users_alta'))
            this.dialogInfoPreMainResidentAndResidents = false
            setTimeout(this.clear, 3000)
          })
          .catch(error => {
            this.loading = false
            console.log(error)
          })
          .finally(() => (this.loading = false))
      } else {
        if (this.confirm === 'false') {
          console.log('Eliminar Todos los Usuarios')
          this.loading = true
          const config = {
            method: 'delete',
            url: 'https://residencial-services.intrare.app/prePrincipalResident/' + this.temporalId + '/validate/',
            headers: {
              'Content-Type': 'application/json',
              'authorization': 'Token ' + store.getters.getToken
            },
            data: {
              'feedback': this.feedback
            }
          }
          axios(config).then(ok => {
            console.log(ok)
            this.loading = false
            this.feedback = null
            this.getMainResidents()
            this.$store.commit('snackbar_activate_true')
            this.$store.commit('snackbar_change_color', 'warning')
            this.$store.commit('snackbar_change_message', this.$t('mensaje_users_baja'))
            this.dialogInfoPreMainResidentAndResidents = false
            setTimeout(this.clear, 3000)
          })
            .catch(error => {
              console.log(error)
              this.loading = false
            })
        }
      }
    },
    activateDeleteResidenceRequest () {
      if (this.confirm === null) {
        this.dialogConfirm = true
      }
      if (this.confirm === 'true') {
        this.loading = true
        this.validateResidenceRequest({
          residentId: this.temporalResidenceRequestId,
          action: 'approve'
        })
          .then(() => {
            this.loading = false
            this.feedback = null
            this.$store.commit('snackbar_activate_true')
            this.$store.commit('snackbar_change_message', this.$t('mensaje_users_alta'))
            this.dialogInfoResidenceRequest = false
            this.getMainResidents()
            this.fetchResidencePendingRequests()
            setTimeout(this.clear, 3000)
          })
          .catch(error => {
            this.loading = false
            console.log(error)
          })
      } else if (this.confirm === 'false') {
        this.loading = true
        this.validateResidenceRequest({
          residentId: this.temporalResidenceRequestId,
          action: 'reject',
          feedback: this.feedback
        })
          .then(() => {
            this.loading = false
            this.feedback = null
            this.$store.commit('snackbar_activate_true')
            this.$store.commit('snackbar_change_color', 'warning')
            this.$store.commit('snackbar_change_message', this.$t('mensaje_users_baja'))
            this.dialogInfoResidenceRequest = false
            this.getMainResidents()
            this.fetchResidencePendingRequests()
            setTimeout(this.clear, 3000)
          })
          .catch(error => {
            this.loading = false
            console.log(error)
          })
      }
    }
  }
}
</script>

<style scoped>
    .edge {
        border-radius: 8px;
        border-color: #81c81b #81c81b #81c81b #81c81b;
        border-width: 3px 3px 3px 3px;
        text-align: center;
        border-style: solid solid solid solid;
    }
    .wrapper{
        width:200px;
        height:200px;
        position: relative;
        margin: 25px auto;
        overflow: hidden;
        border-radius:50%;
        border: 5px solid #81c81b;
    }
    .wrapper img{
        position: relative;
        width:100%;
        height:auto;
    }
    .mr-section-title {
        display: flex;
        align-items: center;
        font-size: 0.95rem;
        font-weight: 600;
        margin-bottom: 12px;
    }
    .mr-doc {
        height: 110px;
        border-radius: 4px;
    }
    .mr-doc-empty {
        display: flex;
        align-items: center;
        justify-content: center;
        background: #f5f5f5;
        border: 1px dashed #bdbdbd;
    }
    .splash-info {
        background: #ffffff;
        position: relative;
        z-index: 2;
        margin-bottom: 30px;
        text-align: center;
        font-size:15px;
        font-weight:bold;
    }
</style>
